// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type AccessCheckCollectionDto = {
    functionality: string;
    missingAccesses: Array<AccessCheckDto>;
};

export type AccessCheckDto = {
    dataBaseAccess: string;
    accessItLink: string;
};

export type AccessCheckFutureDto = {
    /**
     * A human-readable message describing the missing access.
     */
    message: string;
    /**
     * The name of the access/role that is missing.
     */
    accessMissing: string;
    /**
     * The date when the access will be required.
     */
    date: string;
    /**
     * Link to AccessIT to request the missing access.
     */
    accessItLink: string;
};

export type ApiExceptionDto = {
    httpStatusCode: number;
    code: string;
    userMessage?: string | null;
    developerMessage?: string | null;
};

export type ApplicationHealth = {
    applicationName: string;
    requestDate: string;
    readonly resources: Array<Resource>;
};

export type Area = {
    name: string;
    id: string;
    fieldUuid: string;
    center: Point;
    utmCoordinates: PolygonGeometry;
    longLatCoordinates: PolygonGeometry;
    polygonCollection: PolygonFeatureCollection;
};

export type AreaAssignmentDto = {
    areaId: number;
    fieldUuid: string;
    wellboreIds: Array<string>;
};

export type AreaDto = {
    fieldUuid: string;
    fieldIdentifier: string;
    name: string;
};

export type DailyDataSource = {
    dataSource: DataSource;
    pressurePointCount: number;
    onStreamHours?: number | null;
    gradient?: number | null;
    dailyPressureData: Array<DailyPressureData>;
};

export type DailyPressureData = {
    displayName: string;
    pressureValues?: PressureValues;
    pressureType: PressureType;
    measurementPosition?: Point;
    md?: number | null;
    stratigraphy: StratigraphyDto;
    wellboreUuid: string;
    pressureCorrectionWarning?: PressureCorrectionWarning;
    dhpg: number;
};

export enum DataSource {
    DOF = 'DOF',
    DAILY = 'DAILY',
    STATPRESS = 'STATPRESS'
}

export type DataSources = {
    dofDataSource?: DofDataSource;
    dailyDataSource?: DailyDataSource;
    statPressDataSource?: StatPressDataSource;
};

export enum DataType {
    FINAL = 'Final',
    DEPTH_CORRECTED_DATUM = 'DepthCorrectedDatum',
    DEPTH_CORRECTED_TOP_INFLOW = 'DepthCorrectedTopInflow',
    PI_CORRECTED = 'PICorrected',
    RAW = 'Raw',
    GRADIENT = 'Gradient',
    RATE = 'Rate',
    CUMULATIVE_VOLUME = 'CumulativeVolume',
    ON_STREAM_HOURS = 'OnStreamHours',
    PRODUCTIVITY_INDEX = 'ProductivityIndex',
    PRODUCTIVITY_INDEX_INTERPOLATED = 'ProductivityIndexInterpolated'
}

export type DetailTypeDto = {
    id: number;
    name: DetailTypeEnum;
    description?: string | null;
};

export enum DetailTypeEnum {
    UNSPECIFIED = 'Unspecified',
    ZONE_TOP = 'ZoneTop',
    PERFORATION_TOP = 'PerforationTop',
    FAULT = 'Fault',
    CONTACT_GAS_OIL = 'ContactGasOil',
    CONTACT_GAS_WATER = 'ContactGasWater',
    CONTACT_OIL_WATER = 'ContactOilWater',
    ZONE_BASE = 'ZoneBase'
}

export type DofDataSource = {
    dataSource: DataSource;
    shutIn?: boolean | null;
    preferredShutInInterval?: number | null;
    lastShutIn?: DofPressureData;
    dofPressureData: Array<DofPressureData>;
};

export type DofPressureData = {
    displayName: string;
    pressureValues?: PressureValues;
    pressureType: PressureType;
    measurementPosition?: Point;
    md?: number | null;
    stratigraphy: StratigraphyDto;
    wellboreUuid: string;
    pressureCorrectionWarning?: PressureCorrectionWarning;
    dofProdDay: string;
    shutInHrs?: number | null;
};

export type Equipment = {
    name?: string | null;
    mdTop?: number | null;
    tvdTop?: number | null;
    type: PointType;
};

export type EquipmentCollection = {
    gauges?: Array<Equipment> | null;
    screensAndPerforations?: Array<Equipment> | null;
};

export type EquipmentCollectionDto = {
    gauge?: GaugeDto;
    screenOrPerforation: Array<ScreenAndPerfDto>;
};

export enum ExpirationType {
    ARCHIVED = 'Archived',
    REPLACED = 'Replaced'
}

export type FieldConfig = {
    fieldGuid: string;
    fieldName: string;
    lowerPressureBoundary: number;
    upperPressureBoundary: number;
    interpolationIsEnabled: boolean;
    interpolationDaysGapBetweenData: number;
    interpolationDaysAfterNewestData: number;
    piCorrectionIsEnabled: boolean;
    piCorrectionFallbackOilGas: number;
    iiCorrectionIsEnabled: boolean;
    iiCorrectionFallbackGas: number;
    iiCorrectionFallbackWater: number;
    longitude: number;
    latitude: number;
    zoom: number;
    utmZone: number;
    prognosisIsEnabled: boolean;
    dataMapIsEnabled: boolean;
    linePlotIsEnabled: boolean;
    approverRole: string;
    submitterRole: string;
    viewerRole: string;
    approverGroupId: string;
    submitterGroupId: string;
    premoFieldIdentifier?: string | null;
    licenseCommonName?: string | null;
    ciFieldIdentifier?: string | null;
    useSmdaFieldForOutlines: boolean;
};

export type FieldConfigDto = {
    lowerPressureBoundary?: number | null;
    upperPressureBoundary?: number | null;
    interpolationDaysGapBetweenData?: number | null;
    interpolationDaysAfterNewestData?: number | null;
    interpolationIsEnabled?: boolean | null;
    piCorrectionIsEnabled?: boolean | null;
    piCorrectionFallbackOilGas?: number | null;
    iiCorrectionIsEnabled?: boolean | null;
    iiCorrectionFallbackGas?: number | null;
    iiCorrectionFallbackWater?: number | null;
    longitude?: number | null;
    latitude?: number | null;
    zoom?: number | null;
    prognosisIsEnabled?: boolean | null;
    dataMapIsEnabled?: boolean | null;
    linePlotIsEnabled?: boolean | null;
};

export type FieldValuesCollection = {
    areaId: number;
    areaName: string;
    fieldValuesGeneral?: FieldValuesDto;
    fieldValues: Array<FieldValuesDto>;
};

export type FieldValuesCreateUpdateDto = {
    fieldUuid: string;
    fieldIdentifier: string;
    areaId: number;
    stratColumnUuid?: string | null;
    stratColumnIdentifier?: string | null;
    stratUnitUuid?: string | null;
    stratUnitIdentifier?: string | null;
    datumDepth?: number | null;
    pressureDatumInitial?: number | null;
    gradientOil?: number | null;
    gradientGas?: number | null;
    gradientWater?: number | null;
    contactDepthGasOil?: number | null;
    contactDepthOilWater?: number | null;
    contactDepthGasWater?: number | null;
    oilFormationVolFactor?: number | null;
    gasFormationVolFactor?: number | null;
    waterFormationVolFactor?: number | null;
    gasSolution?: number | null;
    isGeneral: boolean;
    isActive: boolean;
};

export type FieldValuesDto = {
    id: number;
    fieldUuid: string;
    fieldIdentifier: string;
    areaId: number;
    areaName?: string | null;
    stratColumnUuid?: string | null;
    stratColumnIdentifier?: string | null;
    stratUnitUuid?: string | null;
    stratUnitIdentifier?: string | null;
    datumDepth?: number | null;
    pressureDatumInitial?: number | null;
    gradientOil?: number | null;
    gradientGas?: number | null;
    gradientWater?: number | null;
    contactDepthGasOil?: number | null;
    contactDepthOilWater?: number | null;
    contactDepthGasWater?: number | null;
    oilFormationVolFactor?: number | null;
    gasFormationVolFactor?: number | null;
    waterFormationVolFactor?: number | null;
    gasSolution?: number | null;
    depthUnit: string;
    pressureUnit: string;
    pressureGradientDepthUnit: string;
    isGeneral: boolean;
    isActive: boolean;
};

export type Filter = {
    id?: string | null;
    title: string;
    createdByEmail: string;
    wellboreIdentifiers: Array<string>;
    ciTargetNames: Array<string>;
    fieldIdentifiers: Array<string>;
    statuses: Array<string>;
    operations: Array<string>;
    operationPhases: Array<string>;
    reservoirZones: Array<string>;
    createUsers: Array<string>;
    mainApprovers: Array<string>;
    backupApprovers: Array<string>;
    approvers: Array<string>;
    createdByMe: boolean;
    isSubscribed: boolean;
    lastModifiedFrom?: string | null;
    lastModifiedTo?: string | null;
};

export type FilterChange = {
    changeId?: string | null;
    date?: string | null;
    from?: number | null;
    to?: number | null;
    filterChangeOrder: number;
    measuredDataFilterId?: string | null;
};

export enum FilterCondition {
    LESSTHAN = 'LESSTHAN',
    LESSTHANOREQUAL = 'LESSTHANOREQUAL',
    EQUAL = 'EQUAL',
    GREATERTHANOREQUAL = 'GREATERTHANOREQUAL',
    GREATERTHAN = 'GREATERTHAN',
    NOTEQUAL = 'NOTEQUAL'
}

export type FilterCreateDto = {
    title: string;
    createdByEmail: string;
    wellboreIdentifiers: Array<string>;
    ciTargetNames: Array<string>;
    fieldIdentifiers: Array<string>;
    statuses: Array<string>;
    operations: Array<string>;
    operationPhases: Array<string>;
    reservoirZones: Array<string>;
    createUsers: Array<string>;
    mainApprovers: Array<string>;
    backupApprovers: Array<string>;
    approvers: Array<string>;
    createdByMe: boolean;
    isSubscribed: boolean;
    lastModifiedFrom?: string | null;
    lastModifiedTo?: string | null;
};

export type FilterCriteria = {
    criteriaId?: string | null;
    criteria: number;
    condition: FilterCondition;
    dataType: FilterDataTypes;
    filterCriteriaOrder: number;
};

export enum FilterDataTypes {
    PRESSURE = 'Pressure',
    INSTANT_PRODUCTION = 'InstantProduction',
    CUMULATIVE_PRODUCTION = 'CumulativeProduction',
    ON_STREAM_HOURS = 'OnStreamHours'
}

export type FilterRule = {
    ruleId?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    criteria: Array<FilterCriteria>;
};

export enum FilterType {
    RULE = 'RULE',
    MANUAL = 'MANUAL',
    DRAG = 'DRAG',
    AUTO = 'AUTO'
}

export type GaugeDepths = {
    gaugeSource?: DataSource;
    gaugeMd: number;
    gaugeMdFinal: number;
    gaugeTvd: number;
    gaugeTvdFinal: number;
};

export type GaugeDto = {
    gaugeMdCorrected?: number | null;
};

export type GeologicalPrognosisReportItem = {
    wellMarkerType?: string | null;
    wellMarkerName?: string | null;
    mdMsl?: Measurement;
    mdRkb?: Measurement;
    tvdMsl?: Measurement;
    tvdRkb?: Measurement;
    mdRkbUncertaintyP05?: Measurement;
    mdRkbUncertaintyP95?: Measurement;
    tvdUncertaintyStdDev?: Measurement;
};

export type GetPrognosesResponse = {
    totalCount: number;
    prognosisDtos: Array<PrognosisDto>;
};

export type HeatMapInput = {
    value: number;
    measurementPosition: Point;
};

export type HeatmapExtentDto = {
    minLatitude: number;
    maxLatitude: number;
    minLongitude: number;
    maxLongitude: number;
    rows: number;
    columns: number;
};

export type HeatmapPointDto = {
    latitude: number;
    longitude: number;
    value: number;
};

export type HeatmapResponseDto = {
    fieldUuid: string;
    measureDate: string;
    extent: HeatmapExtentDto;
    grid: Array<HeatmapPointDto>;
};

export type HelpLine = {
    wellboreGuid: string;
    dataType: DataType;
    helplineCategory: HelplineCategory;
    wellboreName: string;
    pressurePointNumber?: number | null;
    data: Array<HelpLineData>;
    lineType: LineType;
    correctionsWarningString?: string | null;
};

export type HelpLineData = {
    prodDate: string;
    value: number;
    dataType: DataType;
    pressureType?: PressureType;
    shutInHours?: number | null;
};

export type HelpLineInput = {
    wellboreUuid: string;
    helplineCategory: HelplineCategory;
    dataTypes: Array<DataType>;
};

export enum HelplineCategory {
    DHPG1 = 'Dhpg1',
    DHPG2 = 'Dhpg2',
    OTHER = 'Other',
    ONE_HRS_SHUT_IN = 'OneHrsShutIn',
    THREE_HRS_SHUT_IN = 'ThreeHrsShutIn',
    TWELVE_HRS_SHUT_IN = 'TwelveHrsShutIn',
    TWENTY_FOUR_HRS_SHUT_IN = 'TwentyFourHrsShutIn',
    SHOW_ALL_SHUT_INS = 'ShowAllShutIns',
    FLOWING = 'Flowing',
    STAT_PRESS = 'StatPress'
}

export enum HistoryType {
    DRAFT = 'Draft',
    SUBMISSION = 'Submission',
    REJECTION = 'Rejection',
    APPROVAL = 'Approval',
    EXPIRATION = 'Expiration',
    APPROVAL_RETRACTION = 'ApprovalRetraction',
    DISMISS_OUTDATED_WARNINGS = 'DismissOutdatedWarnings'
}

export type InflowStratigraphy = {
    group: Array<string>;
    formation: Array<string>;
    subzone: Array<string>;
};

export enum InterventionSubOperations {
    PUMPING_AND_FLUID = 'PumpingAndFluid',
    WIRELINE_AND_TRACTOR = 'WirelineAndTractor',
    COILED_TUBING = 'CoiledTubing',
    WORKOVER = 'Workover',
    STIMULATION = 'Stimulation'
}

export enum LineType {
    LINE = 'Line',
    POINT = 'Point'
}

export type LookupValues = {
    statuses: Array<StatusEnum>;
    operations: Array<OperationEnum>;
    operationPhases: Array<OperationPhaseEnum>;
    wellbores: Array<string>;
    ciTargets: Array<string>;
    createUsers: Array<string>;
    mainApprovers: Array<string>;
    backupApprovers: Array<string>;
    approveUsers: Array<string>;
    stratColumns: Array<string>;
    reservoirZones: Array<string>;
};

export type MeasuredDataFilter = {
    id?: string | null;
    wellId?: string | null;
    fieldGuid: string;
    title?: string | null;
    filterOrder: number;
    dhpg: number;
    disabled: boolean;
    type: FilterType;
    rule?: FilterRule;
    changes?: Array<FilterChange> | null;
};

export type Measurement = {
    unit?: string | null;
    measure?: number | null;
};

export enum NewWellPhases {
    SUB301 = 'SUB301',
    DW701 = 'DW701',
    DW702 = 'DW702',
    DW703 = 'DW703',
    DW801 = 'DW801',
    DW802 = 'DW802',
    DW550 = 'DW550'
}

export enum NotificationTypeCollaborator {
    EACH_ZONE = 'EachZone',
    ALL_ZONES = 'AllZones',
    NONE = 'None'
}

export enum OperationEnum {
    NEW_WELL = 'NewWell',
    INTERVENTION = 'Intervention',
    P_AND_A = 'PAndA',
    OTHER = 'Other',
    TARGET = 'Target'
}

export enum OperationPhaseEnum {
    SUB301 = 'SUB301',
    DW701 = 'DW701',
    DW702 = 'DW702',
    DW703 = 'DW703',
    PUMPING_AND_FLUID = 'PumpingAndFluid',
    WIRELINE_AND_TRACTOR = 'WirelineAndTractor',
    COILED_TUBING = 'CoiledTubing',
    WORKOVER = 'Workover',
    OTHER = 'Other',
    DW500 = 'DW500',
    STIMULATION = 'Stimulation',
    DW801 = 'DW801',
    DW802 = 'DW802',
    DW550 = 'DW550'
}

export type OptionalAttributesDto = {
    totalDepthRow: boolean;
    commingledZones: boolean;
};

export type OsduWellpath = {
    id: string;
    name?: string | null;
    airGap?: number | null;
    scenarioId?: string | null;
    wellboreEdmId?: string | null;
    wellboreOsduId?: string | null;
    existenceKind?: string | null;
};

export enum OutdatedSource {
    CI = 'Ci',
    SMDA = 'Smda',
    OSDU = 'Osdu',
    POZO = 'Pozo',
    SSDL = 'Ssdl',
    FIELD_VALUES = 'FieldValues'
}

export type OverlappingPrognosisDto = {
    id: number;
    prognosisParentId?: number | null;
    title: string;
    operation?: OperationEnum;
    operationPhase?: OperationPhaseEnum;
    status: StatusEnum;
    ciTargetUuid?: string | null;
    ciTargetName?: string | null;
    ciLicenseCommonName?: string | null;
    ciCountryIdentifier?: string | null;
    ciFieldIdentifier?: string | null;
    ciLatitudeWgs84?: number | null;
    ciLongitudeWgs84?: number | null;
    wellboreIdentifier?: string | null;
    wellboreUuid?: string | null;
    fieldIdentifier?: string | null;
    stratColumnIdentifier?: string | null;
    wellIdentifier?: string | null;
    wellpathOsduId?: string | null;
    wellpathRevision?: string | null;
    scenarioId?: string | null;
    wellboreEdmId?: string | null;
    airGap?: number | null;
    totalDepthDrillerMd?: number | null;
    totalDepthDrillerTvd?: number | null;
    createUser: string;
    updateUser?: string | null;
    mainApprover?: string | null;
    backupApprover?: string | null;
    approveUser?: string | null;
    createDate: string;
    updateDate?: string | null;
    approveDate?: string | null;
    comment?: string | null;
    validFromDate?: string | null;
    validToDate?: string | null;
    optionalAttributes?: OptionalAttributesDto;
    isSubscribed: boolean;
    expirationType?: ExpirationType;
    notificationTypeCollaborator?: NotificationTypeCollaborator;
    currentStep: number;
    isRequestedApprovalRetraction: boolean;
    isRequestedArchived: boolean;
    hasBeenNotifiedAboutExpiration: boolean;
    sharedWith: Array<string>;
    collaborators: Array<string>;
    newStatus?: StatusEnum;
    newValidToDate?: string | null;
};

export type PerforationPremo = {
    name?: string | null;
    mdRkbTop?: number | null;
    tvdRkbTop?: number | null;
};

export type Point = {
    type: string;
    coordinates: Array<number>;
};

export enum PointType {
    SCREEN = 'SCREEN',
    PERFORATION = 'PERFORATION',
    GAUGE = 'GAUGE',
    OTHER = 'OTHER'
}

export type Points = {
    pressurePointNr: number;
    pressurePointSource: DataSource;
    md: number;
    mdFinal: number;
    tvd: number;
    tvdFinal: number;
    pointType: PointType;
    pointTypeFinal: PointType;
    datumDepth: number;
    utm: Array<number>;
    stratigraphy: StratigraphyDto;
};

export type PolygonFeature = {
    type: string;
    properties?: PolygonProperty;
    geometry?: PolygonTransformedGeometry;
};

export type PolygonFeatureCollection = {
    type: string;
    features?: Array<PolygonFeature> | null;
};

export type PolygonGeometry = {
    geometry?: string;
    coordinates?: Array<Array<number>> | null;
};

export type PolygonProperty = {
    display_name?: string | null;
};

export type PolygonTransformedGeometry = {
    type: string;
    coordinates: Array<Array<Array<number>>>;
};

export type PressureCorrectionWarning = {
    hasWarning: boolean;
    dataType: DataType;
    warningMessage?: string | null;
};

export type PressureDataSimple = {
    wellboreUuid: string;
    wellboreName: string;
    prodDay: string;
    dataSources: DataSources;
};

export type PressurePoints = {
    dataSources: Array<DataSource>;
    points?: Array<Points> | null;
    gauge: GaugeDepths;
};

export enum PressureType {
    MEASURED = 'Measured',
    AUTO_CORRECTED = 'AutoCorrected',
    CORRECTED = 'Corrected',
    MISSING = 'Missing',
    INTERPOLATED = 'Interpolated'
}

export type PressureValues = {
    pressureRaw?: number | null;
    pressureDepthCorrectedTopInflow?: number | null;
    pressureDepthCorrectedDatum?: number | null;
    pressurePiCorrected?: number | null;
    pressureFinal?: number | null;
};

export type ProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: unknown;
};

export type ProductivityIndex = {
    wellBoreGuid: string;
    testDate: string;
    pi?: number | null;
    pressureType?: PressureType;
};

export type PrognosisBlobDto = {
    blobName: string;
    prognosisId: number;
    blobUrl: string;
    contentType: string;
    fileName: string;
    content?: string | null;
};

export type PrognosisDetailCreateDto = {
    prognosisId: number;
    detailType?: DetailTypeEnum;
    name?: string | null;
    segment?: string | null;
    stratColumnIdentifier: string;
    reservoirZone: string;
    reservoirZoneNickname?: string | null;
    commingledId?: number | null;
    orderIndex?: number | null;
    tvdMsl?: number | null;
    tvdRkb?: number | null;
    mdRkb?: number | null;
    pressureInitial?: number | null;
    pressureLow?: number | null;
    pressureExpected?: number | null;
    pressureHigh?: number | null;
    pressureFracLow?: number | null;
    pressureFracExpected?: number | null;
    pressureFracHigh?: number | null;
    pressureMinHistorical?: number | null;
    pressureMaxFuture?: number | null;
    pressureMaxFieldLifetime?: number | null;
    pressureMin?: number | null;
    pressureMax?: number | null;
    datumDepth?: number | null;
    pressureDatumLow?: number | null;
    pressureDatumExpected?: number | null;
    pressureDatumHigh?: number | null;
    pressureDatumInitial?: number | null;
    pressureDatumMaxFuture?: number | null;
    pressureDatumMaxFieldLifetime?: number | null;
    gradientOil?: number | null;
    gradientGas?: number | null;
    gradientWater?: number | null;
    contactDepthGasOil?: number | null;
    contactDepthOilWater?: number | null;
    contactDepthGasWater?: number | null;
    temperatureInitial?: number | null;
    temperatureCurrent?: number | null;
    depthUnit: string;
    pressureUnit: string;
    temperatureUnit: string;
    pressureGradientDepthUnit: string;
    comment?: string | null;
    fieldValuesId?: number | null;
};

export type PrognosisDetailDto = {
    id: number;
    prognosisId: number;
    detailType?: DetailTypeEnum;
    name?: string | null;
    segment?: string | null;
    stratColumnIdentifier: string;
    lithostratGroup?: string | null;
    lithostratFormation?: string | null;
    lithostratSubzone?: string | null;
    reservoirZone: string;
    reservoirZoneNickname?: string | null;
    commingledId?: number | null;
    orderIndex?: number | null;
    tvdMsl?: number | null;
    tvdRkb?: number | null;
    mdRkb?: number | null;
    pressureInitial?: number | null;
    pressureLow?: number | null;
    pressureExpected?: number | null;
    pressureHigh?: number | null;
    pressureFracLow?: number | null;
    pressureFracExpected?: number | null;
    pressureFracHigh?: number | null;
    pressureMinHistorical?: number | null;
    pressureMaxFuture?: number | null;
    pressureMaxFieldLifetime?: number | null;
    pressureMin?: number | null;
    pressureMax?: number | null;
    datumDepth?: number | null;
    pressureDatumLow?: number | null;
    pressureDatumExpected?: number | null;
    pressureDatumHigh?: number | null;
    pressureDatumInitial?: number | null;
    pressureDatumMaxFuture?: number | null;
    pressureDatumMaxFieldLifetime?: number | null;
    gradientOil?: number | null;
    gradientGas?: number | null;
    gradientWater?: number | null;
    contactDepthGasOil?: number | null;
    contactDepthOilWater?: number | null;
    contactDepthGasWater?: number | null;
    temperatureInitial?: number | null;
    temperatureCurrent?: number | null;
    depthUnit: string;
    pressureUnit: string;
    temperatureUnit: string;
    pressureGradientDepthUnit: string;
    comment?: string | null;
    updateUser?: string | null;
    updateDate?: string | null;
    markedAsDone: boolean;
    colorHtml?: string | null;
    topAge?: number | null;
    baseAge?: number | null;
    approveDate?: string | null;
    operation?: string | null;
    fieldValuesId?: number | null;
};

export type PrognosisDetailUpdateDto = {
    id: number;
    prognosisId: number;
    detailType?: DetailTypeEnum;
    name?: string | null;
    segment?: string | null;
    stratColumnIdentifier: string;
    reservoirZone: string;
    reservoirZoneNickname?: string | null;
    commingledId?: number | null;
    orderIndex?: number | null;
    tvdMsl?: number | null;
    tvdRkb?: number | null;
    mdRkb?: number | null;
    pressureInitial?: number | null;
    pressureLow?: number | null;
    pressureExpected?: number | null;
    pressureHigh?: number | null;
    pressureFracLow?: number | null;
    pressureFracExpected?: number | null;
    pressureFracHigh?: number | null;
    pressureMinHistorical?: number | null;
    pressureMaxFuture?: number | null;
    pressureMaxFieldLifetime?: number | null;
    pressureMin?: number | null;
    pressureMax?: number | null;
    datumDepth?: number | null;
    pressureDatumLow?: number | null;
    pressureDatumExpected?: number | null;
    pressureDatumHigh?: number | null;
    pressureDatumInitial?: number | null;
    pressureDatumMaxFuture?: number | null;
    pressureDatumMaxFieldLifetime?: number | null;
    gradientOil?: number | null;
    gradientGas?: number | null;
    gradientWater?: number | null;
    contactDepthGasOil?: number | null;
    contactDepthOilWater?: number | null;
    contactDepthGasWater?: number | null;
    temperatureInitial?: number | null;
    temperatureCurrent?: number | null;
    depthUnit: string;
    pressureUnit: string;
    temperatureUnit: string;
    pressureGradientDepthUnit: string;
    comment?: string | null;
    fieldValuesId?: number | null;
};

export type PrognosisDto = {
    id: number;
    prognosisParentId?: number | null;
    title: string;
    operation?: OperationEnum;
    operationPhase?: OperationPhaseEnum;
    status: StatusEnum;
    ciTargetUuid?: string | null;
    ciTargetName?: string | null;
    ciLicenseCommonName?: string | null;
    ciCountryIdentifier?: string | null;
    ciFieldIdentifier?: string | null;
    ciLatitudeWgs84?: number | null;
    ciLongitudeWgs84?: number | null;
    wellboreIdentifier?: string | null;
    wellboreUuid?: string | null;
    fieldIdentifier?: string | null;
    stratColumnIdentifier?: string | null;
    wellIdentifier?: string | null;
    wellpathOsduId?: string | null;
    wellpathRevision?: string | null;
    scenarioId?: string | null;
    wellboreEdmId?: string | null;
    airGap?: number | null;
    totalDepthDrillerMd?: number | null;
    totalDepthDrillerTvd?: number | null;
    createUser: string;
    updateUser?: string | null;
    mainApprover?: string | null;
    backupApprover?: string | null;
    approveUser?: string | null;
    createDate: string;
    updateDate?: string | null;
    approveDate?: string | null;
    comment?: string | null;
    validFromDate?: string | null;
    validToDate?: string | null;
    optionalAttributes?: OptionalAttributesDto;
    isSubscribed: boolean;
    expirationType?: ExpirationType;
    notificationTypeCollaborator?: NotificationTypeCollaborator;
    currentStep: number;
    isRequestedApprovalRetraction: boolean;
    isRequestedArchived: boolean;
    hasBeenNotifiedAboutExpiration: boolean;
    sharedWith: Array<string>;
    collaborators: Array<string>;
};

export type PrognosisHistoryEntryDto = {
    type: HistoryType;
    message: string;
    comment?: string | null;
    date: string;
};

export type PrognosisOutdatedDto = {
    source: OutdatedSource;
    resourceAffected: string;
    dataAffected?: string | null;
    valueOld?: string | null;
    valueNew?: string | null;
};

export type PrognosisStep1Dto = {
    operation: OperationEnum;
    operationPhase?: OperationPhaseEnum;
    ciTargetUuid?: string | null;
    wellboreIdentifier?: string | null;
    wellpathOsduId?: string | null;
    airGap?: number | null;
};

export type PrognosisStep2Dto = {
    mainApprover: string;
    backupApprover?: string | null;
    /**
     * Emails
     */
    collaborators?: Array<string> | null;
    notificationTypeCollaborator?: NotificationTypeCollaborator;
};

export type PrognosisStep3Dto = {
    stratColumnIdentifier: string;
};

export type PrognosisStep5Dto = {
    comment?: string | null;
    validFromDate?: string | null;
    validToDate?: string | null;
};

export type PrognosisUserAnalytics = {
    submittedAllTime: number;
    createdToday: number;
    createdLast7Days: number;
    createdLastMonth: number;
    statusChanges: Array<UserAnalyticsStatusChange>;
    submittedOperations: Array<UserAnalyticsOperation>;
    fields: Array<UserAnalyticsField>;
};

export type Resource = {
    resourceName: string;
    status: string;
    message: string;
};

export type ScreenAndPerfDto = {
    gaugeNo: number;
    mdCorrected?: number | null;
};

export type StatPressDataSource = {
    dataSource: DataSource;
    statPressPressureData: Array<StatPressPressureData>;
};

export type StatPressHelpLine = {
    wellboreGuid: string;
    wellboreName: string;
    formation?: string | null;
    numberOfPointsInGroup: number;
    averagePressureAtDatum?: number | null;
    completionDate?: string | null;
    acquisitionDate?: string | null;
    statPressPressurePoints: Array<StatPressPressurePoint>;
};

export type StatPressPressureData = {
    displayName: string;
    pressureValues?: PressureValues;
    pressureType: PressureType;
    measurementPosition?: Point;
    md?: number | null;
    stratigraphy: StratigraphyDto;
    wellboreUuid: string;
    pressureCorrectionWarning?: PressureCorrectionWarning;
    tvd?: number | null;
    comment?: string | null;
    qualityClassificationEquinor?: string | null;
};

export type StatPressPressurePoint = {
    pressureRaw?: number | null;
    pressureDatum?: number | null;
    md?: number | null;
    tvd?: number | null;
    correctionsWarningString?: string | null;
    comment?: string | null;
    qualityClassificationEquinor?: string | null;
};

export enum StatusEnum {
    DRAFT = 'Draft',
    SUBMITTED = 'Submitted',
    REJECTED = 'Rejected',
    OUTDATED = 'Outdated',
    APPROVED = 'Approved',
    HISTORICAL = 'Historical'
}

export type StratColumn = {
    identifier?: string | null;
    uuid?: string | null;
};

export type StratigraphicUnit = {
    uuid?: string | null;
    stratColumnIdentifier?: string | null;
    stratUnitIdentifier?: string | null;
    stratUnitType?: string | null;
    topAge?: number | null;
    baseAge?: number | null;
    colorHtml?: string | null;
    maxLevels?: number | null;
    stratigraphicUnits: Array<StratigraphicUnit>;
};

export type Stratigraphy = {
    stratColumnIdentifier?: string | null;
    stratUnits: Array<StratigraphicUnit>;
};

export type StratigraphyDto = {
    group?: string | null;
    formation?: string | null;
    subzone?: string | null;
};

export type StringGuidKeyValuePair = {
    key: string | null;
    value: string;
};

export enum TargetPhases {
    SUB301 = 'SUB301',
    OTHER = 'Other',
    DW500 = 'DW500'
}

export type User = {
    userPrincipalName: string;
    shortName: string;
    mail: string;
    displayName: string;
};

export type UserAccess = {
    fieldIdentifier: string;
    fieldUuid: string;
    isFavorite: boolean;
    userRoles: UserRoles;
};

export type UserAnalyticsField = {
    fieldIdentifier: string;
    submittedAllTime: number;
    submittedCount: number;
    approvedCount: number;
    avgRevisions: number;
};

export type UserAnalyticsOperation = {
    operation: string;
    prognosisCount: number;
};

export type UserAnalyticsStatusChange = {
    submissions: number;
    approvals: number;
    rejections: number;
    month: string;
};

export type UserDefaultViewDto = {
    measuredDataMap: boolean;
    linePlot: boolean;
    prognosis: boolean;
};

export type UserRoles = {
    approver: boolean;
    submitter: boolean;
    viewer: boolean;
    backupApprover: boolean;
    fieldAdmin: boolean;
};

export type WellBoreMaster = {
    wellboreUuid: string;
    wellName: string;
    wellboreName: string;
    fieldName: string;
    block: string;
    formation: string;
    purpose: string;
    content: string;
    wellboreStatus?: string | null;
};

export enum WellConfig {
    SCREEN_AND_PERFORATION = 'ScreenAndPerforation',
    SCREEN_ONLY = 'ScreenOnly',
    PERFORATIONS = 'Perforations',
    SINGLE_PERFORATION = 'SinglePerforation',
    NONE = 'None'
}

export type WellTarget = {
    targetUuid?: string | null;
    targetName?: string | null;
    licenseCommonName?: string | null;
    fieldIdentifier?: string | null;
    countryIdentifier?: string | null;
    wbUuid?: string | null;
    latitudeWgs84?: number | null;
    longitudeWgs84?: number | null;
};

export type Wellbore = {
    wellUuid?: string | null;
    wellboreUuid?: string | null;
    uniqueWellIdentifier?: string | null;
    uniqueWellboreIdentifier?: string | null;
    fieldIdentifier?: string | null;
    fieldUuid?: string | null;
    totalDepthDrillerMdRkb?: number | null;
    totalDepthDrillerTvdRkb?: number | null;
    totalDepthDrillerTvdMsl?: number | null;
    airGap?: number | null;
};

export type WellboreDetailed = {
    wellboreUuid: string;
    wellName: string;
    wellboreName: string;
    fieldName: string;
    block: string;
    formation: string;
    purpose: string;
    content: string;
    wellboreStatus?: string | null;
    wellConfig: WellConfig;
    inflowStratigraphy?: InflowStratigraphy;
    pressurePoints?: PressurePoints;
    dofPressurePoint?: PressurePoints;
};

export type WellboreLines = {
    wellboreUuid: string;
    wellPositions: PolygonGeometry;
};

export type WellborePick = {
    pickIdentifier?: string | null;
    stratColumnIdentifier?: string | null;
    mdRkb?: number | null;
    tvdRkb?: number | null;
    mdMsl?: number | null;
    tvdMsl?: number | null;
};

export type ApplicationHealthWritable = {
    applicationName: string;
    requestDate: string;
};

export type PostApiV1AreaAssignmentAssignWellboresData = {
    body?: AreaAssignmentDto;
    path?: never;
    query?: never;
    url: '/api/v1/AreaAssignment/assign-wellbores';
};

export type PostApiV1AreaAssignmentAssignWellboresErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1AreaAssignmentAssignWellboresError = PostApiV1AreaAssignmentAssignWellboresErrors[keyof PostApiV1AreaAssignmentAssignWellboresErrors];

export type PostApiV1AreaAssignmentAssignWellboresResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AreaAssignmentAssignWellboresResponse = PostApiV1AreaAssignmentAssignWellboresResponses[keyof PostApiV1AreaAssignmentAssignWellboresResponses];

export type GetApiV1AreaAssignmentFieldByFieldGuidData = {
    body?: never;
    path: {
        fieldGuid: string;
    };
    query?: never;
    url: '/api/v1/AreaAssignment/field/{fieldGuid}';
};

export type GetApiV1AreaAssignmentFieldByFieldGuidErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1AreaAssignmentFieldByFieldGuidError = GetApiV1AreaAssignmentFieldByFieldGuidErrors[keyof GetApiV1AreaAssignmentFieldByFieldGuidErrors];

export type GetApiV1AreaAssignmentFieldByFieldGuidResponses = {
    /**
     * OK
     */
    200: Array<AreaAssignmentDto>;
};

export type GetApiV1AreaAssignmentFieldByFieldGuidResponse = GetApiV1AreaAssignmentFieldByFieldGuidResponses[keyof GetApiV1AreaAssignmentFieldByFieldGuidResponses];

export type GetApiV1BlobAccessTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Blob/AccessToken';
};

export type GetApiV1BlobAccessTokenErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1BlobAccessTokenResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetApiV1BlobAccessTokenResponse = GetApiV1BlobAccessTokenResponses[keyof GetApiV1BlobAccessTokenResponses];

export type DeleteApiV1BlobByPrognosisIdByBlobNameData = {
    body?: never;
    path: {
        prognosisId: number;
        blobName: string;
    };
    query?: never;
    url: '/api/v1/Blob/{prognosisId}/{blobName}';
};

export type DeleteApiV1BlobByPrognosisIdByBlobNameErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1BlobByPrognosisIdByBlobNameError = DeleteApiV1BlobByPrognosisIdByBlobNameErrors[keyof DeleteApiV1BlobByPrognosisIdByBlobNameErrors];

export type DeleteApiV1BlobByPrognosisIdByBlobNameResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type DeleteApiV1BlobByPrognosisIdByBlobNameResponse = DeleteApiV1BlobByPrognosisIdByBlobNameResponses[keyof DeleteApiV1BlobByPrognosisIdByBlobNameResponses];

export type GetApiV1BlobByPrognosisIdByBlobNameData = {
    body?: never;
    path: {
        prognosisId: number;
        blobName: string;
    };
    query?: never;
    url: '/api/v1/Blob/{prognosisId}/{blobName}';
};

export type GetApiV1BlobByPrognosisIdByBlobNameErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1BlobByPrognosisIdByBlobNameError = GetApiV1BlobByPrognosisIdByBlobNameErrors[keyof GetApiV1BlobByPrognosisIdByBlobNameErrors];

export type GetApiV1BlobByPrognosisIdByBlobNameResponses = {
    /**
     * OK
     */
    200: PrognosisBlobDto;
};

export type GetApiV1BlobByPrognosisIdByBlobNameResponse = GetApiV1BlobByPrognosisIdByBlobNameResponses[keyof GetApiV1BlobByPrognosisIdByBlobNameResponses];

export type PostApiV1BlobByPrognosisIdData = {
    body?: {
        file: Blob | File;
    };
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Blob/{prognosisId}';
};

export type PostApiV1BlobByPrognosisIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1BlobByPrognosisIdError = PostApiV1BlobByPrognosisIdErrors[keyof PostApiV1BlobByPrognosisIdErrors];

export type PostApiV1BlobByPrognosisIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type PostApiV1BlobByPrognosisIdResponse = PostApiV1BlobByPrognosisIdResponses[keyof PostApiV1BlobByPrognosisIdResponses];

export type ClearCacheData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Cache/clear';
};

export type ClearCacheErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
    /**
     * Service Unavailable
     */
    503: unknown;
};

export type ClearCacheError = ClearCacheErrors[keyof ClearCacheErrors];

export type ClearCacheResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ClearCacheResponse = ClearCacheResponses[keyof ClearCacheResponses];

export type GetApiV1CiWellTargetsByTargetUuidData = {
    body?: never;
    path: {
        targetUuid: string;
    };
    query?: never;
    url: '/api/v1/Ci/wellTargets/{targetUuid}';
};

export type GetApiV1CiWellTargetsByTargetUuidErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1CiWellTargetsByTargetUuidResponses = {
    /**
     * OK
     */
    200: WellTarget;
};

export type GetApiV1CiWellTargetsByTargetUuidResponse = GetApiV1CiWellTargetsByTargetUuidResponses[keyof GetApiV1CiWellTargetsByTargetUuidResponses];

export type GetApiV1CiWellTargetsFieldByFieldUuidData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Ci/wellTargets/field/{fieldUuid}';
};

export type GetApiV1CiWellTargetsFieldByFieldUuidErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1CiWellTargetsFieldByFieldUuidResponses = {
    /**
     * OK
     */
    200: Array<WellTarget>;
};

export type GetApiV1CiWellTargetsFieldByFieldUuidResponse = GetApiV1CiWellTargetsFieldByFieldUuidResponses[keyof GetApiV1CiWellTargetsFieldByFieldUuidResponses];

export type GetDataTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Config/datatypes';
};

export type GetDataTypesResponses = {
    /**
     * OK
     */
    200: Array<DataType>;
};

export type GetDataTypesResponse = GetDataTypesResponses[keyof GetDataTypesResponses];

export type GetPressureTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Config/pressureTypes';
};

export type GetPressureTypesResponses = {
    /**
     * OK
     */
    200: Array<PressureType>;
};

export type GetPressureTypesResponse = GetPressureTypesResponses[keyof GetPressureTypesResponses];

export type GetMeasurementTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Config/measurementtypes';
};

export type GetMeasurementTypesResponses = {
    /**
     * OK
     */
    200: Array<HelplineCategory>;
};

export type GetMeasurementTypesResponse = GetMeasurementTypesResponses[keyof GetMeasurementTypesResponses];

export type GetConfigData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Config';
};

export type GetConfigResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: Array<unknown>;
    };
};

export type GetConfigResponse = GetConfigResponses[keyof GetConfigResponses];

export type GetFieldConfigsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Config/fieldConfig';
};

export type GetFieldConfigsResponses = {
    /**
     * OK
     */
    200: Array<FieldConfig>;
};

export type GetFieldConfigsResponse = GetFieldConfigsResponses[keyof GetFieldConfigsResponses];

export type GetFieldConfigData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Config/fieldConfig/{fieldUuid}';
};

export type GetFieldConfigResponses = {
    /**
     * OK
     */
    200: FieldConfig;
};

export type GetFieldConfigResponse = GetFieldConfigResponses[keyof GetFieldConfigResponses];

export type UpdateFieldConfigData = {
    body?: FieldConfigDto;
    path: {
        fieldGuid: string;
    };
    query?: never;
    url: '/api/v1/Config/fieldConfig/{fieldGuid}';
};

export type UpdateFieldConfigResponses = {
    /**
     * OK
     */
    200: FieldConfig;
};

export type UpdateFieldConfigResponse = UpdateFieldConfigResponses[keyof UpdateFieldConfigResponses];

export type GetEquipmentData = {
    body?: never;
    path: {
        wellboreUuid: string;
    };
    query?: never;
    url: '/api/v1/EquipmentMapping/{wellboreUuid}/equipment';
};

export type GetEquipmentErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetEquipmentError = GetEquipmentErrors[keyof GetEquipmentErrors];

export type GetEquipmentResponses = {
    /**
     * OK
     */
    200: EquipmentCollection;
};

export type GetEquipmentResponse = GetEquipmentResponses[keyof GetEquipmentResponses];

export type AddEquipmentData = {
    body?: EquipmentCollectionDto;
    path: {
        fieldUuid: string;
        wellboreUuid: string;
    };
    query?: never;
    url: '/api/v1/EquipmentMapping/field/{fieldUuid}/wellbore/{wellboreUuid}/equipment';
};

export type AddEquipmentErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type AddEquipmentError = AddEquipmentErrors[keyof AddEquipmentErrors];

export type AddEquipmentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type AddEquipmentResponse = AddEquipmentResponses[keyof AddEquipmentResponses];

export type GetFieldOutlinesData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Field/{fieldUuid}/Outlines';
};

export type GetFieldOutlinesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetFieldOutlinesError = GetFieldOutlinesErrors[keyof GetFieldOutlinesErrors];

export type GetFieldOutlinesResponses = {
    /**
     * OK
     */
    200: PolygonFeatureCollection;
};

export type GetFieldOutlinesResponse = GetFieldOutlinesResponses[keyof GetFieldOutlinesResponses];

export type GetFieldFaultLinesData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Field/{fieldUuid}/FaultLines';
};

export type GetFieldFaultLinesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetFieldFaultLinesError = GetFieldFaultLinesErrors[keyof GetFieldFaultLinesErrors];

export type GetFieldFaultLinesResponses = {
    /**
     * OK
     */
    200: PolygonFeatureCollection;
};

export type GetFieldFaultLinesResponse = GetFieldFaultLinesResponses[keyof GetFieldFaultLinesResponses];

export type GetAreasData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Field/{fieldUuid}/areas';
};

export type GetAreasErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetAreasError = GetAreasErrors[keyof GetAreasErrors];

export type GetAreasResponses = {
    /**
     * OK
     */
    200: Array<Area>;
    /**
     * No Content
     */
    204: void;
};

export type GetAreasResponse = GetAreasResponses[keyof GetAreasResponses];

export type GetWellsInAreaData = {
    body?: never;
    path: {
        fieldUuId: string;
        area: string;
    };
    query?: never;
    url: '/api/v1/Field/{fieldUuId}/areas/{area}/wells';
};

export type GetWellsInAreaResponses = {
    /**
     * OK
     */
    200: Array<WellBoreMaster>;
};

export type GetWellsInAreaResponse = GetWellsInAreaResponses[keyof GetWellsInAreaResponses];

export type GetWellpositionsData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Field/{fieldUuid}/wellpositions';
};

export type GetWellpositionsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetWellpositionsError = GetWellpositionsErrors[keyof GetWellpositionsErrors];

export type GetWellpositionsResponses = {
    /**
     * OK
     */
    200: Array<WellboreLines>;
    /**
     * No Content
     */
    204: void;
};

export type GetWellpositionsResponse = GetWellpositionsResponses[keyof GetWellpositionsResponses];

export type GetApiV1FieldValuesFieldByFieldUuidData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: {
        onlyIsActive?: boolean;
    };
    url: '/api/v1/FieldValues/Field/{fieldUuid}';
};

export type GetApiV1FieldValuesFieldByFieldUuidErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1FieldValuesFieldByFieldUuidError = GetApiV1FieldValuesFieldByFieldUuidErrors[keyof GetApiV1FieldValuesFieldByFieldUuidErrors];

export type GetApiV1FieldValuesFieldByFieldUuidResponses = {
    /**
     * OK
     */
    200: Array<FieldValuesCollection>;
};

export type GetApiV1FieldValuesFieldByFieldUuidResponse = GetApiV1FieldValuesFieldByFieldUuidResponses[keyof GetApiV1FieldValuesFieldByFieldUuidResponses];

export type PostApiV1FieldValuesData = {
    body?: FieldValuesCreateUpdateDto;
    path?: never;
    query?: never;
    url: '/api/v1/FieldValues';
};

export type PostApiV1FieldValuesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1FieldValuesError = PostApiV1FieldValuesErrors[keyof PostApiV1FieldValuesErrors];

export type PostApiV1FieldValuesResponses = {
    /**
     * Created
     */
    201: number;
};

export type PostApiV1FieldValuesResponse = PostApiV1FieldValuesResponses[keyof PostApiV1FieldValuesResponses];

export type DeleteApiV1FieldValuesByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/FieldValues/{id}';
};

export type DeleteApiV1FieldValuesByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1FieldValuesByIdError = DeleteApiV1FieldValuesByIdErrors[keyof DeleteApiV1FieldValuesByIdErrors];

export type DeleteApiV1FieldValuesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FieldValuesByIdResponse = DeleteApiV1FieldValuesByIdResponses[keyof DeleteApiV1FieldValuesByIdResponses];

export type PutApiV1FieldValuesByIdData = {
    body?: FieldValuesCreateUpdateDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/FieldValues/{id}';
};

export type PutApiV1FieldValuesByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1FieldValuesByIdError = PutApiV1FieldValuesByIdErrors[keyof PutApiV1FieldValuesByIdErrors];

export type PutApiV1FieldValuesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1FieldValuesByIdResponse = PutApiV1FieldValuesByIdResponses[keyof PutApiV1FieldValuesByIdResponses];

export type PostApiV1FieldValuesAreasData = {
    body?: AreaDto;
    path?: never;
    query?: never;
    url: '/api/v1/FieldValues/areas';
};

export type PostApiV1FieldValuesAreasErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1FieldValuesAreasError = PostApiV1FieldValuesAreasErrors[keyof PostApiV1FieldValuesAreasErrors];

export type PostApiV1FieldValuesAreasResponses = {
    /**
     * Created
     */
    201: number;
};

export type PostApiV1FieldValuesAreasResponse = PostApiV1FieldValuesAreasResponses[keyof PostApiV1FieldValuesAreasResponses];

export type DeleteApiV1FieldValuesAreasByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/FieldValues/areas/{id}';
};

export type DeleteApiV1FieldValuesAreasByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1FieldValuesAreasByIdError = DeleteApiV1FieldValuesAreasByIdErrors[keyof DeleteApiV1FieldValuesAreasByIdErrors];

export type DeleteApiV1FieldValuesAreasByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FieldValuesAreasByIdResponse = DeleteApiV1FieldValuesAreasByIdResponses[keyof DeleteApiV1FieldValuesAreasByIdResponses];

export type PutApiV1FieldValuesAreasByIdData = {
    body?: AreaDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/FieldValues/areas/{id}';
};

export type PutApiV1FieldValuesAreasByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1FieldValuesAreasByIdError = PutApiV1FieldValuesAreasByIdErrors[keyof PutApiV1FieldValuesAreasByIdErrors];

export type PutApiV1FieldValuesAreasByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1FieldValuesAreasByIdResponse = PutApiV1FieldValuesAreasByIdResponses[keyof PutApiV1FieldValuesAreasByIdResponses];

export type GetApiV1FieldValuesFieldValuesWarningByFieldUuidData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: {
        onlyIsActive?: boolean;
    };
    url: '/api/v1/FieldValues/FieldValuesWarning/{fieldUuid}';
};

export type GetApiV1FieldValuesFieldValuesWarningByFieldUuidErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1FieldValuesFieldValuesWarningByFieldUuidError = GetApiV1FieldValuesFieldValuesWarningByFieldUuidErrors[keyof GetApiV1FieldValuesFieldValuesWarningByFieldUuidErrors];

export type GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponse = GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponses[keyof GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponses];

export type GetApiV1FilterData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Filter';
};

export type GetApiV1FilterErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1FilterResponses = {
    /**
     * OK
     */
    200: Array<Filter>;
};

export type GetApiV1FilterResponse = GetApiV1FilterResponses[keyof GetApiV1FilterResponses];

export type PostApiV1FilterData = {
    body?: FilterCreateDto;
    path?: never;
    query?: never;
    url: '/api/v1/Filter';
};

export type PostApiV1FilterErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1FilterError = PostApiV1FilterErrors[keyof PostApiV1FilterErrors];

export type PostApiV1FilterResponses = {
    /**
     * Created
     */
    201: string;
};

export type PostApiV1FilterResponse = PostApiV1FilterResponses[keyof PostApiV1FilterResponses];

export type DeleteApiV1FilterByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Filter/{id}';
};

export type DeleteApiV1FilterByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1FilterByIdError = DeleteApiV1FilterByIdErrors[keyof DeleteApiV1FilterByIdErrors];

export type DeleteApiV1FilterByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FilterByIdResponse = DeleteApiV1FilterByIdResponses[keyof DeleteApiV1FilterByIdResponses];

export type PatchApiV1FilterByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        title: string;
    };
    url: '/api/v1/Filter/{id}';
};

export type PatchApiV1FilterByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1FilterByIdError = PatchApiV1FilterByIdErrors[keyof PatchApiV1FilterByIdErrors];

export type PatchApiV1FilterByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1FilterByIdResponse = PatchApiV1FilterByIdResponses[keyof PatchApiV1FilterByIdResponses];

export type GetApiV1HealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Health';
};

export type GetApiV1HealthResponses = {
    /**
     * OK
     */
    200: ApplicationHealth;
};

export type GetApiV1HealthResponse = GetApiV1HealthResponses[keyof GetApiV1HealthResponses];

export type GetHelpLinesData = {
    body?: Array<HelpLineInput>;
    path: {
        fieldUuId: string;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
    };
    url: '/api/v1/HelpLine/{fieldUuId}';
};

export type GetHelpLinesResponses = {
    /**
     * OK
     */
    200: Array<HelpLine>;
};

export type GetHelpLinesResponse = GetHelpLinesResponses[keyof GetHelpLinesResponses];

export type GetStatPressHelpLinesData = {
    body?: Array<HelpLineInput>;
    path: {
        fieldUuId: string;
    };
    query?: never;
    url: '/api/v1/HelpLine/{fieldUuId}/getStatPressPressure';
};

export type GetStatPressHelpLinesResponses = {
    /**
     * OK
     */
    200: Array<StatPressHelpLine>;
};

export type GetStatPressHelpLinesResponse = GetStatPressHelpLinesResponses[keyof GetStatPressHelpLinesResponses];

export type GetApiV1PrognosesByPrognosisIdLastSubmittedData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/LastSubmitted';
};

export type GetApiV1PrognosesByPrognosisIdLastSubmittedErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdLastSubmittedError = GetApiV1PrognosesByPrognosisIdLastSubmittedErrors[keyof GetApiV1PrognosesByPrognosisIdLastSubmittedErrors];

export type GetApiV1PrognosesByPrognosisIdLastSubmittedResponses = {
    /**
     * OK
     */
    200: PrognosisDto;
};

export type GetApiV1PrognosesByPrognosisIdLastSubmittedResponse = GetApiV1PrognosesByPrognosisIdLastSubmittedResponses[keyof GetApiV1PrognosesByPrognosisIdLastSubmittedResponses];

export type GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/Details/LastSubmitted';
};

export type GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedError = GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedErrors[keyof GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedErrors];

export type GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDetailDto>;
};

export type GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponse = GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponses[keyof GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponses];

export type GetApiV1PrognosesLookupValuesData = {
    body?: never;
    path?: never;
    query?: {
        fieldIdentifiers?: Array<string>;
    };
    url: '/api/v1/Prognoses/LookupValues';
};

export type GetApiV1PrognosesLookupValuesErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesLookupValuesResponses = {
    /**
     * OK
     */
    200: LookupValues;
};

export type GetApiV1PrognosesLookupValuesResponse = GetApiV1PrognosesLookupValuesResponses[keyof GetApiV1PrognosesLookupValuesResponses];

export type GetFiltersData = {
    body?: never;
    path?: never;
    query?: {
        wellId?: string;
        dhpg?: number;
    };
    url: '/api/v1/MeasuredDataFilter';
};

export type GetFiltersResponses = {
    /**
     * OK
     */
    200: Array<MeasuredDataFilter>;
};

export type GetFiltersResponse = GetFiltersResponses[keyof GetFiltersResponses];

export type SaveFilterData = {
    body?: MeasuredDataFilter;
    path?: never;
    query?: never;
    url: '/api/v1/MeasuredDataFilter';
};

export type SaveFilterResponses = {
    /**
     * OK
     */
    200: MeasuredDataFilter;
};

export type SaveFilterResponse = SaveFilterResponses[keyof SaveFilterResponses];

export type UpdateFilterData = {
    body?: MeasuredDataFilter;
    path?: never;
    query?: never;
    url: '/api/v1/MeasuredDataFilter';
};

export type UpdateFilterResponses = {
    /**
     * OK
     */
    200: MeasuredDataFilter;
};

export type UpdateFilterResponse = UpdateFilterResponses[keyof UpdateFilterResponses];

export type BulkUpdateFilterData = {
    body?: Array<MeasuredDataFilter>;
    path?: never;
    query?: never;
    url: '/api/v1/MeasuredDataFilter/bulkupdate';
};

export type BulkUpdateFilterResponses = {
    /**
     * OK
     */
    200: Array<MeasuredDataFilter>;
};

export type BulkUpdateFilterResponse = BulkUpdateFilterResponses[keyof BulkUpdateFilterResponses];

export type DeleteFilterByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MeasuredDataFilter/{id}';
};

export type DeleteFilterByIdResponses = {
    /**
     * OK
     */
    200: StringGuidKeyValuePair;
};

export type DeleteFilterByIdResponse = DeleteFilterByIdResponses[keyof DeleteFilterByIdResponses];

export type GetFilterByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MeasuredDataFilter/{id}';
};

export type GetFilterByIdResponses = {
    /**
     * OK
     */
    200: MeasuredDataFilter;
};

export type GetFilterByIdResponse = GetFilterByIdResponses[keyof GetFilterByIdResponses];

export type BulkDeleteFilterByIdData = {
    body?: Array<string>;
    path?: never;
    query?: never;
    url: '/api/v1/MeasuredDataFilter/bulkDelete';
};

export type BulkDeleteFilterByIdResponses = {
    /**
     * OK
     */
    200: Array<StringGuidKeyValuePair>;
};

export type BulkDeleteFilterByIdResponse = BulkDeleteFilterByIdResponses[keyof BulkDeleteFilterByIdResponses];

export type GetApiV1OptionalAttributesByPrognosisIdData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/OptionalAttributes/{prognosisId}';
};

export type GetApiV1OptionalAttributesByPrognosisIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1OptionalAttributesByPrognosisIdError = GetApiV1OptionalAttributesByPrognosisIdErrors[keyof GetApiV1OptionalAttributesByPrognosisIdErrors];

export type GetApiV1OptionalAttributesByPrognosisIdResponses = {
    /**
     * OK
     */
    200: OptionalAttributesDto;
};

export type GetApiV1OptionalAttributesByPrognosisIdResponse = GetApiV1OptionalAttributesByPrognosisIdResponses[keyof GetApiV1OptionalAttributesByPrognosisIdResponses];

export type PostApiV1OptionalAttributesByPrognosisIdData = {
    body?: OptionalAttributesDto;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/OptionalAttributes/{prognosisId}';
};

export type PostApiV1OptionalAttributesByPrognosisIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1OptionalAttributesByPrognosisIdError = PostApiV1OptionalAttributesByPrognosisIdErrors[keyof PostApiV1OptionalAttributesByPrognosisIdErrors];

export type PostApiV1OptionalAttributesByPrognosisIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1OptionalAttributesByPrognosisIdResponse = PostApiV1OptionalAttributesByPrognosisIdResponses[keyof PostApiV1OptionalAttributesByPrognosisIdResponses];

export type PutApiV1OptionalAttributesByPrognosisIdData = {
    body?: OptionalAttributesDto;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/OptionalAttributes/{prognosisId}';
};

export type PutApiV1OptionalAttributesByPrognosisIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1OptionalAttributesByPrognosisIdError = PutApiV1OptionalAttributesByPrognosisIdErrors[keyof PutApiV1OptionalAttributesByPrognosisIdErrors];

export type PutApiV1OptionalAttributesByPrognosisIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1OptionalAttributesByPrognosisIdResponse = PutApiV1OptionalAttributesByPrognosisIdResponses[keyof PutApiV1OptionalAttributesByPrognosisIdResponses];

export type GetApiV1OsduWellboresByWellboreIdentifierWellpathsData = {
    body?: never;
    path: {
        wellboreIdentifier: string;
    };
    query?: never;
    url: '/api/v1/Osdu/wellbores/{wellboreIdentifier}/wellpaths';
};

export type GetApiV1OsduWellboresByWellboreIdentifierWellpathsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponses = {
    /**
     * OK
     */
    200: Array<OsduWellpath>;
};

export type GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponse = GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponses[keyof GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponses];

export type GetApiV1OsduWellpathsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Osdu/wellpaths/{id}';
};

export type GetApiV1OsduWellpathsByIdErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1OsduWellpathsByIdResponses = {
    /**
     * OK
     */
    200: OsduWellpath;
};

export type GetApiV1OsduWellpathsByIdResponse = GetApiV1OsduWellpathsByIdResponses[keyof GetApiV1OsduWellpathsByIdResponses];

export type GetApiV1PrognosesByPrognosisIdOverlappingData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/overlapping';
};

export type GetApiV1PrognosesByPrognosisIdOverlappingErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdOverlappingError = GetApiV1PrognosesByPrognosisIdOverlappingErrors[keyof GetApiV1PrognosesByPrognosisIdOverlappingErrors];

export type GetApiV1PrognosesByPrognosisIdOverlappingResponses = {
    /**
     * OK
     */
    200: Array<OverlappingPrognosisDto>;
};

export type GetApiV1PrognosesByPrognosisIdOverlappingResponse = GetApiV1PrognosesByPrognosisIdOverlappingResponses[keyof GetApiV1PrognosesByPrognosisIdOverlappingResponses];

export type GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthData = {
    body?: never;
    path: {
        id: number;
        stratColumnIdentifier: string;
        stratUnitIdentifier: string;
    };
    query?: {
        detailType?: DetailTypeEnum;
    };
    url: '/api/v1/Pozo/prognosis/{id}/stratColumn/{stratColumnIdentifier}/stratUnit/{stratUnitIdentifier}/prognosedDepth';
};

export type GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthError = GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthErrors[keyof GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthErrors];

export type GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponses = {
    /**
     * OK
     */
    200: GeologicalPrognosisReportItem;
};

export type GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponse = GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponses[keyof GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponses];

export type GetApiV1PozoPrognosisByIdFaultsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Pozo/prognosis/{id}/faults';
};

export type GetApiV1PozoPrognosisByIdFaultsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PozoPrognosisByIdFaultsResponses = {
    /**
     * OK
     */
    200: Array<GeologicalPrognosisReportItem>;
};

export type GetApiV1PozoPrognosisByIdFaultsResponse = GetApiV1PozoPrognosisByIdFaultsResponses[keyof GetApiV1PozoPrognosisByIdFaultsResponses];

export type GetPressureDataByFieldFlatData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: {
        measureDate?: string;
    };
    url: '/api/v1/Pressure/Field/{fieldUuid}/pressureField';
};

export type GetPressureDataByFieldFlatResponses = {
    /**
     * OK
     */
    200: Array<PressureDataSimple>;
};

export type GetPressureDataByFieldFlatResponse = GetPressureDataByFieldFlatResponses[keyof GetPressureDataByFieldFlatResponses];

export type GetPressureHeatmapData = {
    /**
     * Heatmap input gives the values that is used to create the heat map
     */
    body?: Array<HeatMapInput>;
    path: {
        fieldUuid: string;
    };
    query?: {
        /**
         * Date of pressure measurements.
         */
        measureDate?: string;
        /**
         * Target point count (numeric). Grid uses nearest square (rows=columns=round(sqrt(resolution))). Default: 10000.
         */
        resolution?: number;
        /**
         * Number of nearest wells affecting each interpolation point. Default: 8.
         */
        neighborCount?: number;
        /**
         * IDW power (higher gives stronger local influence). Default: 2.0.
         */
        idwPower?: number;
        /**
         * Buffer around the pressure points bounding box in kilometres. Default: 5.0 km.
         */
        bufferKm?: number;
    };
    url: '/api/v1/Pressure/Field/{fieldUuid}/heatmap';
};

export type GetPressureHeatmapErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetPressureHeatmapError = GetPressureHeatmapErrors[keyof GetPressureHeatmapErrors];

export type GetPressureHeatmapResponses = {
    /**
     * OK
     */
    200: HeatmapResponseDto;
};

export type GetPressureHeatmapResponse = GetPressureHeatmapResponses[keyof GetPressureHeatmapResponses];

export type GetPiLinePlotData = {
    body?: Array<string>;
    path: {
        fieldUuid: string;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
    };
    url: '/api/v1/Pressure/pressurecorrection/{fieldUuid}/GetPiLinePlot';
};

export type GetPiLinePlotResponses = {
    /**
     * OK
     */
    200: Array<ProductivityIndex>;
};

export type GetPiLinePlotResponse = GetPiLinePlotResponses[keyof GetPiLinePlotResponses];

export type GetApiV1PrognosesData = {
    body?: never;
    path?: never;
    query?: {
        WellboreIdentifier?: string;
        CiTargetName?: string;
        FieldIdentifier?: string;
        Status?: string;
        Operation?: string;
        OperationPhase?: string;
        StratColumnIdentifier?: string;
        ReservoirZone?: string;
        Comment?: string;
        CreateUser?: string;
        MainApprover?: string;
        BackupApprover?: string;
        ApproveUser?: string;
        IsSubscribed?: boolean;
        IsCollaborator?: boolean;
        IsSharedWith?: boolean;
        UpdateDateFrom?: string;
        UpdateDateTo?: string;
        ValidDateFrom?: string;
        ValidDateTo?: string;
        SortColumn?: string;
        SortDirection?: string;
        Page?: number;
        PageSize?: number;
    };
    url: '/api/v1/Prognoses';
};

export type GetApiV1PrognosesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesError = GetApiV1PrognosesErrors[keyof GetApiV1PrognosesErrors];

export type GetApiV1PrognosesResponses = {
    /**
     * OK
     */
    200: GetPrognosesResponse;
};

export type GetApiV1PrognosesResponse = GetApiV1PrognosesResponses[keyof GetApiV1PrognosesResponses];

export type PostApiV1PrognosesData = {
    body?: PrognosisStep1Dto;
    path?: never;
    query: {
        fieldIdentifier: string;
    };
    url: '/api/v1/Prognoses';
};

export type PostApiV1PrognosesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1PrognosesError = PostApiV1PrognosesErrors[keyof PostApiV1PrognosesErrors];

export type PostApiV1PrognosesResponses = {
    /**
     * Created
     */
    201: number;
};

export type PostApiV1PrognosesResponse = PostApiV1PrognosesResponses[keyof PostApiV1PrognosesResponses];

export type DeleteApiV1PrognosesByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}';
};

export type DeleteApiV1PrognosesByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1PrognosesByIdError = DeleteApiV1PrognosesByIdErrors[keyof DeleteApiV1PrognosesByIdErrors];

export type DeleteApiV1PrognosesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PrognosesByIdResponse = DeleteApiV1PrognosesByIdResponses[keyof DeleteApiV1PrognosesByIdResponses];

export type GetApiV1PrognosesByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}';
};

export type GetApiV1PrognosesByIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByIdError = GetApiV1PrognosesByIdErrors[keyof GetApiV1PrognosesByIdErrors];

export type GetApiV1PrognosesByIdResponses = {
    /**
     * OK
     */
    200: PrognosisDto;
};

export type GetApiV1PrognosesByIdResponse = GetApiV1PrognosesByIdResponses[keyof GetApiV1PrognosesByIdResponses];

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdData = {
    body?: never;
    path: {
        edmWellboreId: string;
        scenarioId: string;
    };
    query?: never;
    url: '/api/v1/Prognoses/edmWellbore/{edmWellboreId}/scenario/{scenarioId}';
};

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ApiExceptionDto;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdError = GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdErrors[keyof GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdErrors];

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponses = {
    /**
     * OK
     */
    200: PrognosisDto;
    /**
     * No Content
     */
    204: void;
};

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponse = GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponses[keyof GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponses];

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdData = {
    body?: never;
    path: {
        edmWellboreId: string;
    };
    query?: never;
    url: '/api/v1/Prognoses/edmWellbore/{edmWellboreId}';
};

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdErrors = {
    /**
     * Forbidden
     */
    403: ApiExceptionDto;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdError = GetApiV1PrognosesEdmWellboreByEdmWellboreIdErrors[keyof GetApiV1PrognosesEdmWellboreByEdmWellboreIdErrors];

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDto>;
};

export type GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponse = GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponses[keyof GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponses];

export type PostApiV1PrognosesByIdCopyData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        isRevision?: boolean;
    };
    url: '/api/v1/Prognoses/{id}/copy';
};

export type PostApiV1PrognosesByIdCopyErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1PrognosesByIdCopyError = PostApiV1PrognosesByIdCopyErrors[keyof PostApiV1PrognosesByIdCopyErrors];

export type PostApiV1PrognosesByIdCopyResponses = {
    /**
     * Created
     */
    201: number;
};

export type PostApiV1PrognosesByIdCopyResponse = PostApiV1PrognosesByIdCopyResponses[keyof PostApiV1PrognosesByIdCopyResponses];

export type PatchApiV1PrognosesByIdStep1Data = {
    body?: PrognosisStep1Dto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}/step-1';
};

export type PatchApiV1PrognosesByIdStep1Errors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdStep1Error = PatchApiV1PrognosesByIdStep1Errors[keyof PatchApiV1PrognosesByIdStep1Errors];

export type PatchApiV1PrognosesByIdStep1Responses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdStep1Response = PatchApiV1PrognosesByIdStep1Responses[keyof PatchApiV1PrognosesByIdStep1Responses];

export type PatchApiV1PrognosesByIdStep2Data = {
    body?: PrognosisStep2Dto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}/step-2';
};

export type PatchApiV1PrognosesByIdStep2Errors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdStep2Error = PatchApiV1PrognosesByIdStep2Errors[keyof PatchApiV1PrognosesByIdStep2Errors];

export type PatchApiV1PrognosesByIdStep2Responses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdStep2Response = PatchApiV1PrognosesByIdStep2Responses[keyof PatchApiV1PrognosesByIdStep2Responses];

export type PatchApiV1PrognosesByIdStep3Data = {
    body?: PrognosisStep3Dto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}/step-3';
};

export type PatchApiV1PrognosesByIdStep3Errors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdStep3Error = PatchApiV1PrognosesByIdStep3Errors[keyof PatchApiV1PrognosesByIdStep3Errors];

export type PatchApiV1PrognosesByIdStep3Responses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdStep3Response = PatchApiV1PrognosesByIdStep3Responses[keyof PatchApiV1PrognosesByIdStep3Responses];

export type PatchApiV1PrognosesByIdStep5Data = {
    body?: PrognosisStep5Dto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}/step-5';
};

export type PatchApiV1PrognosesByIdStep5Errors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdStep5Error = PatchApiV1PrognosesByIdStep5Errors[keyof PatchApiV1PrognosesByIdStep5Errors];

export type PatchApiV1PrognosesByIdStep5Responses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdStep5Response = PatchApiV1PrognosesByIdStep5Responses[keyof PatchApiV1PrognosesByIdStep5Responses];

export type PatchApiV1PrognosesByIdStepData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        step?: number;
    };
    url: '/api/v1/Prognoses/{id}/step';
};

export type PatchApiV1PrognosesByIdStepErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdStepError = PatchApiV1PrognosesByIdStepErrors[keyof PatchApiV1PrognosesByIdStepErrors];

export type PatchApiV1PrognosesByIdStepResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdStepResponse = PatchApiV1PrognosesByIdStepResponses[keyof PatchApiV1PrognosesByIdStepResponses];

export type PatchApiV1PrognosesByIdSubmitData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/submit';
};

export type PatchApiV1PrognosesByIdSubmitErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdSubmitError = PatchApiV1PrognosesByIdSubmitErrors[keyof PatchApiV1PrognosesByIdSubmitErrors];

export type PatchApiV1PrognosesByIdSubmitResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdSubmitResponse = PatchApiV1PrognosesByIdSubmitResponses[keyof PatchApiV1PrognosesByIdSubmitResponses];

export type PatchApiV1PrognosesByIdReturnToDraftData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/returnToDraft';
};

export type PatchApiV1PrognosesByIdReturnToDraftErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdReturnToDraftError = PatchApiV1PrognosesByIdReturnToDraftErrors[keyof PatchApiV1PrognosesByIdReturnToDraftErrors];

export type PatchApiV1PrognosesByIdReturnToDraftResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdReturnToDraftResponse = PatchApiV1PrognosesByIdReturnToDraftResponses[keyof PatchApiV1PrognosesByIdReturnToDraftResponses];

export type PatchApiV1PrognosesByIdRejectData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/reject';
};

export type PatchApiV1PrognosesByIdRejectErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdRejectError = PatchApiV1PrognosesByIdRejectErrors[keyof PatchApiV1PrognosesByIdRejectErrors];

export type PatchApiV1PrognosesByIdRejectResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdRejectResponse = PatchApiV1PrognosesByIdRejectResponses[keyof PatchApiV1PrognosesByIdRejectResponses];

export type PatchApiV1PrognosesByIdRetractData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/retract';
};

export type PatchApiV1PrognosesByIdRetractErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdRetractError = PatchApiV1PrognosesByIdRetractErrors[keyof PatchApiV1PrognosesByIdRetractErrors];

export type PatchApiV1PrognosesByIdRetractResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdRetractResponse = PatchApiV1PrognosesByIdRetractResponses[keyof PatchApiV1PrognosesByIdRetractResponses];

export type PatchApiV1PrognosesByIdApproveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/approve';
};

export type PatchApiV1PrognosesByIdApproveErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdApproveError = PatchApiV1PrognosesByIdApproveErrors[keyof PatchApiV1PrognosesByIdApproveErrors];

export type PatchApiV1PrognosesByIdApproveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdApproveResponse = PatchApiV1PrognosesByIdApproveResponses[keyof PatchApiV1PrognosesByIdApproveResponses];

export type PatchApiV1PrognosesByIdExpireData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/expire';
};

export type PatchApiV1PrognosesByIdExpireErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdExpireError = PatchApiV1PrognosesByIdExpireErrors[keyof PatchApiV1PrognosesByIdExpireErrors];

export type PatchApiV1PrognosesByIdExpireResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdExpireResponse = PatchApiV1PrognosesByIdExpireResponses[keyof PatchApiV1PrognosesByIdExpireResponses];

export type PatchApiV1PrognosesByIdRequestApprovalRetractionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/requestApprovalRetraction';
};

export type PatchApiV1PrognosesByIdRequestApprovalRetractionErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdRequestApprovalRetractionError = PatchApiV1PrognosesByIdRequestApprovalRetractionErrors[keyof PatchApiV1PrognosesByIdRequestApprovalRetractionErrors];

export type PatchApiV1PrognosesByIdRequestApprovalRetractionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdRequestApprovalRetractionResponse = PatchApiV1PrognosesByIdRequestApprovalRetractionResponses[keyof PatchApiV1PrognosesByIdRequestApprovalRetractionResponses];

export type PatchApiV1PrognosesByIdDismissApprovalRetractionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}/dismissApprovalRetraction';
};

export type PatchApiV1PrognosesByIdDismissApprovalRetractionErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdDismissApprovalRetractionError = PatchApiV1PrognosesByIdDismissApprovalRetractionErrors[keyof PatchApiV1PrognosesByIdDismissApprovalRetractionErrors];

export type PatchApiV1PrognosesByIdDismissApprovalRetractionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdDismissApprovalRetractionResponse = PatchApiV1PrognosesByIdDismissApprovalRetractionResponses[keyof PatchApiV1PrognosesByIdDismissApprovalRetractionResponses];

export type PatchApiV1PrognosesByIdRequestArchivingData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/Prognoses/{id}/requestArchiving';
};

export type PatchApiV1PrognosesByIdRequestArchivingErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdRequestArchivingError = PatchApiV1PrognosesByIdRequestArchivingErrors[keyof PatchApiV1PrognosesByIdRequestArchivingErrors];

export type PatchApiV1PrognosesByIdRequestArchivingResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdRequestArchivingResponse = PatchApiV1PrognosesByIdRequestArchivingResponses[keyof PatchApiV1PrognosesByIdRequestArchivingResponses];

export type PatchApiV1PrognosesByIdDismissArchivingData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{id}/dismissArchiving';
};

export type PatchApiV1PrognosesByIdDismissArchivingErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesByIdDismissArchivingError = PatchApiV1PrognosesByIdDismissArchivingErrors[keyof PatchApiV1PrognosesByIdDismissArchivingErrors];

export type PatchApiV1PrognosesByIdDismissArchivingResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesByIdDismissArchivingResponse = PatchApiV1PrognosesByIdDismissArchivingResponses[keyof PatchApiV1PrognosesByIdDismissArchivingResponses];

export type GetApiV1PrognosesByPrognosisIdDetailsData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/Details';
};

export type GetApiV1PrognosesByPrognosisIdDetailsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdDetailsError = GetApiV1PrognosesByPrognosisIdDetailsErrors[keyof GetApiV1PrognosesByPrognosisIdDetailsErrors];

export type GetApiV1PrognosesByPrognosisIdDetailsResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDetailDto>;
};

export type GetApiV1PrognosesByPrognosisIdDetailsResponse = GetApiV1PrognosesByPrognosisIdDetailsResponses[keyof GetApiV1PrognosesByPrognosisIdDetailsResponses];

export type DeleteApiV1PrognosesDetailsData = {
    body?: Array<number>;
    path?: never;
    query?: never;
    url: '/api/v1/Prognoses/Details';
};

export type DeleteApiV1PrognosesDetailsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1PrognosesDetailsError = DeleteApiV1PrognosesDetailsErrors[keyof DeleteApiV1PrognosesDetailsErrors];

export type DeleteApiV1PrognosesDetailsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PrognosesDetailsResponse = DeleteApiV1PrognosesDetailsResponses[keyof DeleteApiV1PrognosesDetailsResponses];

export type PostApiV1PrognosesDetailsData = {
    body?: Array<PrognosisDetailCreateDto>;
    path?: never;
    query?: never;
    url: '/api/v1/Prognoses/Details';
};

export type PostApiV1PrognosesDetailsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1PrognosesDetailsError = PostApiV1PrognosesDetailsErrors[keyof PostApiV1PrognosesDetailsErrors];

export type PostApiV1PrognosesDetailsResponses = {
    /**
     * Created
     */
    201: Array<PrognosisDetailDto>;
};

export type PostApiV1PrognosesDetailsResponse = PostApiV1PrognosesDetailsResponses[keyof PostApiV1PrognosesDetailsResponses];

export type PutApiV1PrognosesDetailsData = {
    body?: Array<PrognosisDetailUpdateDto>;
    path?: never;
    query?: never;
    url: '/api/v1/Prognoses/Details';
};

export type PutApiV1PrognosesDetailsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1PrognosesDetailsError = PutApiV1PrognosesDetailsErrors[keyof PutApiV1PrognosesDetailsErrors];

export type PutApiV1PrognosesDetailsResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDetailDto>;
};

export type PutApiV1PrognosesDetailsResponse = PutApiV1PrognosesDetailsResponses[keyof PutApiV1PrognosesDetailsResponses];

export type PatchApiV1PrognosesDetailsByDetailIdCommentData = {
    body?: never;
    path: {
        detailId: number;
    };
    query?: {
        comment?: string;
    };
    url: '/api/v1/Prognoses/Details/{detailId}/comment';
};

export type PatchApiV1PrognosesDetailsByDetailIdCommentErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesDetailsByDetailIdCommentError = PatchApiV1PrognosesDetailsByDetailIdCommentErrors[keyof PatchApiV1PrognosesDetailsByDetailIdCommentErrors];

export type PatchApiV1PrognosesDetailsByDetailIdCommentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesDetailsByDetailIdCommentResponse = PatchApiV1PrognosesDetailsByDetailIdCommentResponses[keyof PatchApiV1PrognosesDetailsByDetailIdCommentResponses];

export type PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData = {
    body?: never;
    path: {
        detailId: number;
    };
    query?: {
        markAsDone?: boolean;
        currentDetailUpdateDate?: string;
    };
    url: '/api/v1/Prognoses/Details/{detailId}/mark-as-done';
};

export type PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneError = PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneErrors[keyof PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneErrors];

export type PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponse = PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponses[keyof PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponses];

export type GetApiV1PrognosesDetailsHistoricData = {
    body?: never;
    path?: never;
    query: {
        WellboreIdentifier?: string;
        TargetUuid?: string;
        StratColumnIdentifier: string;
        ReservoirZone: string;
    };
    url: '/api/v1/Prognoses/Details/Historic';
};

export type GetApiV1PrognosesDetailsHistoricErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesDetailsHistoricError = GetApiV1PrognosesDetailsHistoricErrors[keyof GetApiV1PrognosesDetailsHistoricErrors];

export type GetApiV1PrognosesDetailsHistoricResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDetailDto>;
};

export type GetApiV1PrognosesDetailsHistoricResponse = GetApiV1PrognosesDetailsHistoricResponses[keyof GetApiV1PrognosesDetailsHistoricResponses];

export type GetApiV1PrognosesDetailsCommingledHistoricData = {
    body?: never;
    path?: never;
    query: {
        prognosisId: number;
        commingledId: number;
    };
    url: '/api/v1/Prognoses/Details/Commingled/Historic';
};

export type GetApiV1PrognosesDetailsCommingledHistoricErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesDetailsCommingledHistoricError = GetApiV1PrognosesDetailsCommingledHistoricErrors[keyof GetApiV1PrognosesDetailsCommingledHistoricErrors];

export type GetApiV1PrognosesDetailsCommingledHistoricResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDetailDto>;
};

export type GetApiV1PrognosesDetailsCommingledHistoricResponse = GetApiV1PrognosesDetailsCommingledHistoricResponses[keyof GetApiV1PrognosesDetailsCommingledHistoricResponses];

export type GetApiV1PrognosesDetailsTypesData = {
    body?: never;
    path?: never;
    query?: {
        operation?: OperationEnum;
    };
    url: '/api/v1/Prognoses/details/types';
};

export type GetApiV1PrognosesDetailsTypesErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesDetailsTypesResponses = {
    /**
     * OK
     */
    200: Array<DetailTypeDto>;
};

export type GetApiV1PrognosesDetailsTypesResponse = GetApiV1PrognosesDetailsTypesResponses[keyof GetApiV1PrognosesDetailsTypesResponses];

export type GetApiV1PrognosesByPrognosisIdHistoryData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/History';
};

export type GetApiV1PrognosesByPrognosisIdHistoryErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdHistoryError = GetApiV1PrognosesByPrognosisIdHistoryErrors[keyof GetApiV1PrognosesByPrognosisIdHistoryErrors];

export type GetApiV1PrognosesByPrognosisIdHistoryResponses = {
    /**
     * OK
     */
    200: Array<PrognosisHistoryEntryDto>;
};

export type GetApiV1PrognosesByPrognosisIdHistoryResponse = GetApiV1PrognosesByPrognosisIdHistoryResponses[keyof GetApiV1PrognosesByPrognosisIdHistoryResponses];

export type GetApiV1PrognosesByPrognosisIdRevisionsData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/revisions';
};

export type GetApiV1PrognosesByPrognosisIdRevisionsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdRevisionsError = GetApiV1PrognosesByPrognosisIdRevisionsErrors[keyof GetApiV1PrognosesByPrognosisIdRevisionsErrors];

export type GetApiV1PrognosesByPrognosisIdRevisionsResponses = {
    /**
     * OK
     */
    200: Array<PrognosisDto>;
};

export type GetApiV1PrognosesByPrognosisIdRevisionsResponse = GetApiV1PrognosesByPrognosisIdRevisionsResponses[keyof GetApiV1PrognosesByPrognosisIdRevisionsResponses];

export type GetApiV1PrognosesByPrognosisIdRevisionsNewestData = {
    body?: never;
    path: {
        prognosisId: number;
    };
    query?: never;
    url: '/api/v1/Prognoses/{prognosisId}/revisions/newest';
};

export type GetApiV1PrognosesByPrognosisIdRevisionsNewestErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByPrognosisIdRevisionsNewestError = GetApiV1PrognosesByPrognosisIdRevisionsNewestErrors[keyof GetApiV1PrognosesByPrognosisIdRevisionsNewestErrors];

export type GetApiV1PrognosesByPrognosisIdRevisionsNewestResponses = {
    /**
     * OK
     */
    200: PrognosisDto;
};

export type GetApiV1PrognosesByPrognosisIdRevisionsNewestResponse = GetApiV1PrognosesByPrognosisIdRevisionsNewestResponses[keyof GetApiV1PrognosesByPrognosisIdRevisionsNewestResponses];

export type GetApiV1PrognosesByIdOutdatedEntriesData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/prognoses/{id}/outdated-entries';
};

export type GetApiV1PrognosesByIdOutdatedEntriesErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesByIdOutdatedEntriesError = GetApiV1PrognosesByIdOutdatedEntriesErrors[keyof GetApiV1PrognosesByIdOutdatedEntriesErrors];

export type GetApiV1PrognosesByIdOutdatedEntriesResponses = {
    /**
     * OK
     */
    200: Array<PrognosisOutdatedDto>;
};

export type GetApiV1PrognosesByIdOutdatedEntriesResponse = GetApiV1PrognosesByIdOutdatedEntriesResponses[keyof GetApiV1PrognosesByIdOutdatedEntriesResponses];

export type PostApiV1PrognosesByIdOutdatedEntriesDismissData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        comment?: string;
    };
    url: '/api/v1/prognoses/{id}/outdated-entries/dismiss';
};

export type PostApiV1PrognosesByIdOutdatedEntriesDismissErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1PrognosesByIdOutdatedEntriesDismissError = PostApiV1PrognosesByIdOutdatedEntriesDismissErrors[keyof PostApiV1PrognosesByIdOutdatedEntriesDismissErrors];

export type PostApiV1PrognosesByIdOutdatedEntriesDismissResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1TargetsUpdatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/targets/updates';
};

export type PostApiV1TargetsUpdatesErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1TargetsUpdatesError = PostApiV1TargetsUpdatesErrors[keyof PostApiV1TargetsUpdatesErrors];

export type PostApiV1TargetsUpdatesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1WellboresUpdatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/wellbores/updates';
};

export type PostApiV1WellboresUpdatesErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1WellboresUpdatesError = PostApiV1WellboresUpdatesErrors[keyof PostApiV1WellboresUpdatesErrors];

export type PostApiV1WellboresUpdatesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1WellPathsUpdatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/well-paths/updates';
};

export type PostApiV1WellPathsUpdatesErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1WellPathsUpdatesError = PostApiV1WellPathsUpdatesErrors[keyof PostApiV1WellPathsUpdatesErrors];

export type PostApiV1WellPathsUpdatesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1FieldValuesUpdatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/field-values/updates';
};

export type PostApiV1FieldValuesUpdatesErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1FieldValuesUpdatesError = PostApiV1FieldValuesUpdatesErrors[keyof PostApiV1FieldValuesUpdatesErrors];

export type PostApiV1FieldValuesUpdatesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1WellborePicksUpdatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/wellbore-picks/updates';
};

export type PostApiV1WellborePicksUpdatesErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1WellborePicksUpdatesError = PostApiV1WellborePicksUpdatesErrors[keyof PostApiV1WellborePicksUpdatesErrors];

export type PostApiV1WellborePicksUpdatesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1PrognosedDepthsUpdatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/prognosed-depths/updates';
};

export type PostApiV1PrognosedDepthsUpdatesErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1PrognosedDepthsUpdatesError = PostApiV1PrognosedDepthsUpdatesErrors[keyof PostApiV1PrognosedDepthsUpdatesErrors];

export type PostApiV1PrognosedDepthsUpdatesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type DeleteApiV1PrognosisSubscriptionData = {
    body?: never;
    path?: never;
    query: {
        prognosisId: number;
        email: string;
    };
    url: '/api/v1/PrognosisSubscription';
};

export type DeleteApiV1PrognosisSubscriptionErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type DeleteApiV1PrognosisSubscriptionError = DeleteApiV1PrognosisSubscriptionErrors[keyof DeleteApiV1PrognosisSubscriptionErrors];

export type DeleteApiV1PrognosisSubscriptionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PrognosisSubscriptionResponse = DeleteApiV1PrognosisSubscriptionResponses[keyof DeleteApiV1PrognosisSubscriptionResponses];

export type PostApiV1PrognosisSubscriptionData = {
    body?: never;
    path?: never;
    query: {
        prognosisId: number;
        email: string;
    };
    url: '/api/v1/PrognosisSubscription';
};

export type PostApiV1PrognosisSubscriptionErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1PrognosisSubscriptionError = PostApiV1PrognosisSubscriptionErrors[keyof PostApiV1PrognosisSubscriptionErrors];

export type PostApiV1PrognosisSubscriptionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PrognosisSubscriptionResponse = PostApiV1PrognosisSubscriptionResponses[keyof PostApiV1PrognosisSubscriptionResponses];

export type PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData = {
    body: Array<string>;
    path: {
        prognosisId: number;
    };
    query?: {
        emailComment?: string;
    };
    url: '/api/v1/PrognosisSubscription/prognoses/{prognosisId}/share';
};

export type PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareError = PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareErrors[keyof PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareErrors];

export type PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponse = PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponses[keyof PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponses];

export type GetApiV1PrognosesSyncData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Prognoses/sync';
};

export type GetApiV1PrognosesSyncErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesSyncError = GetApiV1PrognosesSyncErrors[keyof GetApiV1PrognosesSyncErrors];

export type GetApiV1PrognosesSyncResponses = {
    /**
     * OK
     */
    200: Array<number>;
};

export type GetApiV1PrognosesSyncResponse = GetApiV1PrognosesSyncResponses[keyof GetApiV1PrognosesSyncResponses];

export type GetApiV1PrognosesSyncWithDetailsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Prognoses/sync/withDetails';
};

export type GetApiV1PrognosesSyncWithDetailsErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1PrognosesSyncWithDetailsError = GetApiV1PrognosesSyncWithDetailsErrors[keyof GetApiV1PrognosesSyncWithDetailsErrors];

export type GetApiV1PrognosesSyncWithDetailsResponses = {
    /**
     * OK
     */
    200: Array<number>;
};

export type GetApiV1PrognosesSyncWithDetailsResponse = GetApiV1PrognosesSyncWithDetailsResponses[keyof GetApiV1PrognosesSyncWithDetailsResponses];

export type GetApiV1ReservoirZonesTopUsedData = {
    body?: never;
    path?: never;
    query: {
        WellboreIdentifier?: string;
        TargetUuid?: string;
        StratColumnIdentifier: string;
        Operation: OperationEnum;
    };
    url: '/api/v1/ReservoirZones/topUsed';
};

export type GetApiV1ReservoirZonesTopUsedErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1ReservoirZonesTopUsedError = GetApiV1ReservoirZonesTopUsedErrors[keyof GetApiV1ReservoirZonesTopUsedErrors];

export type GetApiV1ReservoirZonesTopUsedResponses = {
    /**
     * OK
     */
    200: Array<StratigraphicUnit>;
};

export type GetApiV1ReservoirZonesTopUsedResponse = GetApiV1ReservoirZonesTopUsedResponses[keyof GetApiV1ReservoirZonesTopUsedResponses];

export type GetApiV1ReservoirZonesLastUsedData = {
    body?: never;
    path?: never;
    query: {
        WellboreIdentifier?: string;
        TargetUuid?: string;
        StratColumnIdentifier: string;
        Operation: OperationEnum;
    };
    url: '/api/v1/ReservoirZones/lastUsed';
};

export type GetApiV1ReservoirZonesLastUsedErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1ReservoirZonesLastUsedError = GetApiV1ReservoirZonesLastUsedErrors[keyof GetApiV1ReservoirZonesLastUsedErrors];

export type GetApiV1ReservoirZonesLastUsedResponses = {
    /**
     * OK
     */
    200: Array<StratigraphicUnit>;
};

export type GetApiV1ReservoirZonesLastUsedResponse = GetApiV1ReservoirZonesLastUsedResponses[keyof GetApiV1ReservoirZonesLastUsedResponses];

export type GetApiV1SamUserAnalyticsPrognosisData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Sam/userAnalytics/prognosis';
};

export type GetApiV1SamUserAnalyticsPrognosisErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SamUserAnalyticsPrognosisResponses = {
    /**
     * OK
     */
    200: PrognosisUserAnalytics;
};

export type GetApiV1SamUserAnalyticsPrognosisResponse = GetApiV1SamUserAnalyticsPrognosisResponses[keyof GetApiV1SamUserAnalyticsPrognosisResponses];

export type GetApiV1SmdaWellboresByWellboreIdentifierData = {
    body?: never;
    path: {
        wellboreIdentifier: string;
    };
    query?: never;
    url: '/api/v1/Smda/Wellbores/{wellboreIdentifier}';
};

export type GetApiV1SmdaWellboresByWellboreIdentifierErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SmdaWellboresByWellboreIdentifierResponses = {
    /**
     * OK
     */
    200: Wellbore;
};

export type GetApiV1SmdaWellboresByWellboreIdentifierResponse = GetApiV1SmdaWellboresByWellboreIdentifierResponses[keyof GetApiV1SmdaWellboresByWellboreIdentifierResponses];

export type GetApiV1SmdaFieldsByFieldUuidWellboresAllData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Smda/Fields/{fieldUuid}/Wellbores/All';
};

export type GetApiV1SmdaFieldsByFieldUuidWellboresAllErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SmdaFieldsByFieldUuidWellboresAllResponses = {
    /**
     * OK
     */
    200: Array<Wellbore>;
};

export type GetApiV1SmdaFieldsByFieldUuidWellboresAllResponse = GetApiV1SmdaFieldsByFieldUuidWellboresAllResponses[keyof GetApiV1SmdaFieldsByFieldUuidWellboresAllResponses];

export type GetApiV1SmdaFieldsByFieldUuidStratColumnsData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/Smda/Fields/{fieldUuid}/StratColumns';
};

export type GetApiV1SmdaFieldsByFieldUuidStratColumnsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SmdaFieldsByFieldUuidStratColumnsResponses = {
    /**
     * OK
     */
    200: Array<StratColumn>;
};

export type GetApiV1SmdaFieldsByFieldUuidStratColumnsResponse = GetApiV1SmdaFieldsByFieldUuidStratColumnsResponses[keyof GetApiV1SmdaFieldsByFieldUuidStratColumnsResponses];

export type GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllData = {
    body?: never;
    path: {
        stratColumnIdentifier: string;
    };
    query?: never;
    url: '/api/v1/Smda/Wellbores/StratColumns/{stratColumnIdentifier}/StratUnits/All';
};

export type GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponses = {
    /**
     * OK
     */
    200: Stratigraphy;
};

export type GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponse = GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponses[keyof GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponses];

export type GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickData = {
    body?: never;
    path: {
        wellboreUuid: string;
        stratColumnIdentifier: string;
        stratUnitIdentifier: string;
    };
    query?: {
        detailType?: DetailTypeEnum;
    };
    url: '/api/v1/Smda/Wellbores/{wellboreUuid}/StratColumns/{stratColumnIdentifier}/StratUnits/{stratUnitIdentifier}/Pick';
};

export type GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickError = GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickErrors[keyof GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickErrors];

export type GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponses = {
    /**
     * OK
     */
    200: WellborePick;
};

export type GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponse = GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponses[keyof GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponses];

export type PostApiV1SmdaUpdateRelationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Smda/update-relation';
};

export type PostApiV1SmdaUpdateRelationErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostApiV1SmdaUpdateRelationError = PostApiV1SmdaUpdateRelationErrors[keyof PostApiV1SmdaUpdateRelationErrors];

export type PostApiV1SmdaUpdateRelationResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1SsdlWellboresByWellboreUuidPerforationsData = {
    body?: never;
    path: {
        wellboreUuid: string;
    };
    query?: never;
    url: '/api/v1/Ssdl/wellbores/{wellboreUuid}/perforations';
};

export type GetApiV1SsdlWellboresByWellboreUuidPerforationsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1SsdlWellboresByWellboreUuidPerforationsResponses = {
    /**
     * OK
     */
    200: Array<PerforationPremo>;
};

export type GetApiV1SsdlWellboresByWellboreUuidPerforationsResponse = GetApiV1SsdlWellboresByWellboreUuidPerforationsResponses[keyof GetApiV1SsdlWellboresByWellboreUuidPerforationsResponses];

export type GetTokenData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/Token/{clientId}';
};

export type GetTokenResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetTokenResponse = GetTokenResponses[keyof GetTokenResponses];

export type GetSamPortalTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Token/SamPortal';
};

export type GetSamPortalTokenResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetSamPortalTokenResponse = GetSamPortalTokenResponses[keyof GetSamPortalTokenResponses];

export type GetSamPortalProductionTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Token/SamPortal/Production';
};

export type GetSamPortalProductionTokenResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetSamPortalProductionTokenResponse = GetSamPortalProductionTokenResponses[keyof GetSamPortalProductionTokenResponses];

export type GetApiV1UserUserAccessData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/User/UserAccess';
};

export type GetApiV1UserUserAccessErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserUserAccessResponses = {
    /**
     * OK
     */
    200: Array<UserAccess>;
};

export type GetApiV1UserUserAccessResponse = GetApiV1UserUserAccessResponses[keyof GetApiV1UserUserAccessResponses];

export type GetApiV1UserAccessCheckCollectionByFieldUuidData = {
    body?: never;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/User/accessCheckCollection/{fieldUuid}';
};

export type GetApiV1UserAccessCheckCollectionByFieldUuidErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserAccessCheckCollectionByFieldUuidResponses = {
    /**
     * OK
     */
    200: Array<AccessCheckCollectionDto>;
};

export type GetApiV1UserAccessCheckCollectionByFieldUuidResponse = GetApiV1UserAccessCheckCollectionByFieldUuidResponses[keyof GetApiV1UserAccessCheckCollectionByFieldUuidResponses];

export type GetApiV1UserFutureAccessesData = {
    body?: never;
    path?: never;
    query: {
        fieldIdentifier: string;
    };
    url: '/api/v1/User/future-accesses';
};

export type GetApiV1UserFutureAccessesErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserFutureAccessesResponses = {
    /**
     * OK
     */
    200: Array<AccessCheckFutureDto>;
};

export type GetApiV1UserFutureAccessesResponse = GetApiV1UserFutureAccessesResponses[keyof GetApiV1UserFutureAccessesResponses];

export type GetApiV1UserApproversByFieldIdentifierData = {
    body?: never;
    path: {
        fieldIdentifier: string;
    };
    query?: never;
    url: '/api/v1/User/Approvers/{fieldIdentifier}';
};

export type GetApiV1UserApproversByFieldIdentifierErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserApproversByFieldIdentifierResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserApproversByFieldIdentifierResponse = GetApiV1UserApproversByFieldIdentifierResponses[keyof GetApiV1UserApproversByFieldIdentifierResponses];

export type GetApiV1UserApproversByFieldIdentifierAllData = {
    body?: never;
    path: {
        fieldIdentifier: string;
    };
    query?: never;
    url: '/api/v1/User/Approvers/{fieldIdentifier}/all';
};

export type GetApiV1UserApproversByFieldIdentifierAllErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserApproversByFieldIdentifierAllResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserApproversByFieldIdentifierAllResponse = GetApiV1UserApproversByFieldIdentifierAllResponses[keyof GetApiV1UserApproversByFieldIdentifierAllResponses];

export type GetApiV1UserSubmittersByFieldIdentifierData = {
    body?: never;
    path: {
        fieldIdentifier: string;
    };
    query?: never;
    url: '/api/v1/User/submitters/{fieldIdentifier}';
};

export type GetApiV1UserSubmittersByFieldIdentifierErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserSubmittersByFieldIdentifierResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserSubmittersByFieldIdentifierResponse = GetApiV1UserSubmittersByFieldIdentifierResponses[keyof GetApiV1UserSubmittersByFieldIdentifierResponses];

export type GetApiV1UserSubmittersByFieldIdentifierAllData = {
    body?: never;
    path: {
        fieldIdentifier: string;
    };
    query?: never;
    url: '/api/v1/User/submitters/{fieldIdentifier}/all';
};

export type GetApiV1UserSubmittersByFieldIdentifierAllErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserSubmittersByFieldIdentifierAllResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserSubmittersByFieldIdentifierAllResponse = GetApiV1UserSubmittersByFieldIdentifierAllResponses[keyof GetApiV1UserSubmittersByFieldIdentifierAllResponses];

export type GetApiV1UserApproversByFieldIdentifierBackupData = {
    body?: never;
    path: {
        fieldIdentifier: string;
    };
    query?: never;
    url: '/api/v1/User/Approvers/{fieldIdentifier}/Backup';
};

export type GetApiV1UserApproversByFieldIdentifierBackupErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserApproversByFieldIdentifierBackupResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserApproversByFieldIdentifierBackupResponse = GetApiV1UserApproversByFieldIdentifierBackupResponses[keyof GetApiV1UserApproversByFieldIdentifierBackupResponses];

export type GetApiV1UserApproversByFieldIdentifierBackupAllData = {
    body?: never;
    path: {
        fieldIdentifier: string;
    };
    query?: never;
    url: '/api/v1/User/Approvers/{fieldIdentifier}/Backup/all';
};

export type GetApiV1UserApproversByFieldIdentifierBackupAllErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserApproversByFieldIdentifierBackupAllResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserApproversByFieldIdentifierBackupAllResponse = GetApiV1UserApproversByFieldIdentifierBackupAllResponses[keyof GetApiV1UserApproversByFieldIdentifierBackupAllResponses];

export type GetApiV1UserData = {
    body?: never;
    path?: never;
    query: {
        searchTerm: string;
    };
    url: '/api/v1/User';
};

export type GetApiV1UserErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserResponses = {
    /**
     * OK
     */
    200: Array<User>;
};

export type GetApiV1UserResponse = GetApiV1UserResponses[keyof GetApiV1UserResponses];

export type GetApiV1UserShortnamesData = {
    body?: never;
    path?: never;
    query?: {
        shortnames?: Array<string>;
    };
    url: '/api/v1/User/shortnames';
};

export type GetApiV1UserShortnamesErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserShortnamesResponses = {
    /**
     * OK
     */
    200: {
        [key: string]: User;
    };
};

export type GetApiV1UserShortnamesResponse = GetApiV1UserShortnamesResponses[keyof GetApiV1UserShortnamesResponses];

export type GetApiV1UserPhotoByShortnameData = {
    body?: never;
    path: {
        shortname: string;
    };
    query?: never;
    url: '/api/v1/User/Photo/{shortname}';
};

export type GetApiV1UserPhotoByShortnameErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserPhotoByShortnameResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetApiV1UserPhotoByShortnameResponse = GetApiV1UserPhotoByShortnameResponses[keyof GetApiV1UserPhotoByShortnameResponses];

export type GetApiV1UserDefaultViewData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/User/defaultView';
};

export type GetApiV1UserDefaultViewErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetApiV1UserDefaultViewResponses = {
    /**
     * OK
     */
    200: UserDefaultViewDto;
};

export type GetApiV1UserDefaultViewResponse = GetApiV1UserDefaultViewResponses[keyof GetApiV1UserDefaultViewResponses];

export type PutApiV1UserDefaultViewData = {
    body?: UserDefaultViewDto;
    path?: never;
    query?: never;
    url: '/api/v1/User/defaultView';
};

export type PutApiV1UserDefaultViewErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1UserDefaultViewError = PutApiV1UserDefaultViewErrors[keyof PutApiV1UserDefaultViewErrors];

export type PutApiV1UserDefaultViewResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1UserDefaultViewResponse = PutApiV1UserDefaultViewResponses[keyof PutApiV1UserDefaultViewResponses];

export type PutApiV1UserFavoriteFieldsByFieldUuidData = {
    body: boolean;
    path: {
        fieldUuid: string;
    };
    query?: never;
    url: '/api/v1/User/favoriteFields/{fieldUuid}';
};

export type PutApiV1UserFavoriteFieldsByFieldUuidErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PutApiV1UserFavoriteFieldsByFieldUuidError = PutApiV1UserFavoriteFieldsByFieldUuidErrors[keyof PutApiV1UserFavoriteFieldsByFieldUuidErrors];

export type PutApiV1UserFavoriteFieldsByFieldUuidResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1UserFavoriteFieldsByFieldUuidResponse = PutApiV1UserFavoriteFieldsByFieldUuidResponses[keyof PutApiV1UserFavoriteFieldsByFieldUuidResponses];

export type GetDrilledWellsFeaturesByFieldData = {
    body?: never;
    path: {
        fieldUuId: string;
    };
    query?: never;
    url: '/api/v1/Well/{fieldUuId}/drilledwells';
};

export type GetDrilledWellsFeaturesByFieldResponses = {
    /**
     * OK
     */
    200: Array<WellboreDetailed>;
};

export type GetDrilledWellsFeaturesByFieldResponse = GetDrilledWellsFeaturesByFieldResponses[keyof GetDrilledWellsFeaturesByFieldResponses];
